const translations = {
  "en":{
    "dashboard":"Dashboard",
    "outlet_coverage":"Outlet Coverage",
    "called_rate":"Called Rate",
    "team_efficiency":"Team Efficiency",
    "assigned":"Assigned",
    "scheduled":"Scheduled",
    "coverage":"Coverage",
    "summary_by_area":"Summary by Area",
    "summary_by_agent":"Summary by Agent",
    "vs_last_month":"vs Last Month",
    "vs":"vs",
    "graph_period":"Graph Period",
    "table_period":"Table Period",
    "overview":"Overview",
    "oos_count":"OOS Count",
    "outlets":"Outlets",
    "products_affected":"Products Affected",
    "summary_by_product":"Summary by Product",
    "from_master_list":"From outlet master list",
    "from":"From",
    "to":"To",
    "attended_label":"Attended",
    "unassigned":"Unassigned",
    "transaction":"Transactions",
    "monthly_sales":"Monthly Sales",
    "semiannual_sales":"Semi Annual Sales",
    "logout":"Logout",
    "top_salesman":"TOP SALESMAN",
    "top_customer":"TOP CUSTOMER",
    "sales":"SALES",
    "outstanding":"OUTSTANDING",
    "top_items":"Top Selling Items",
    "total":"TOTAL",
    "es_backend":"EASYM",
    "proceed_logout":"You are proceeding to logout. By logging out, the system will clear cache data which includes theme, language, chosen search criteria and so on. You can set them back upon your next login.",
    "logout_cap":"LOGOUT",
    "cancel":"CANCEL",
    "search_anything":"Search Anything",
    "search":"Search...",
    "search_cap":"SEARCH",
    "clear":"CLEAR",
    "clear_all":"CLEAR ALL",
    "delete":"Delete",
    "selected":"selected",
    "total_selected":"Total selected",
    "no_matches_found":"No matches found",
    "try_different_keyword":"Try a different keyword",
    "settings":"Settings",
    "save":"SAVE",
    "rows_per_page":"Rows per page",
    "table_info":"Transaction Table Info",
    "search_crit":"Search Criteria",
    "today":"Today",
    "yesterday":"Yesterday",
    "last_week":"Last 1 Week",
    "last_month":"Last 1 Month",
    "choose_date":"Choose Date",
    "doc_date":"Document Date",
    "del_date":"Delivery Date",
    "ok":"OKAY",
    "active_doc":"Active Documents",
    "inactive_doc":"Inactive Documents",
    "pending_doc":"Pending Documents",
    "salesman":"AGENT",
    "customer":"Outlet",
    "cust_list":"Outlet List",
    "cust_not_in_list":"Customer Not in List",
    "no_internet":"You are not connected to internet",
    "doc_details":"Doc Details",
    "active_doc_done":"In-App documents loaded",
    "confirm_doc_done":"Confirmed documents loaded",
    "trans_doc_done":"Transferred documents loaded",
    "posted_doc_done":"Posted documents loaded",
    "doc_dtl_fail":"Document details loading failed",
    "inapp_doc":"In-App Documents",
    "confirmed_doc":"Confirmed Documents",
    "trans_doc":"Transferred Documents",
    "posted_doc":"Posted Documents",
    "reset_selection":"RESET",
    "export_column_settings":"Export Columns",
    "product_info_columns":"Product Info Columns",
    "stock_data_columns":"Stock Data Columns (Per Visit)",
    "item_code":"Item Code",
    "item_name":"Item Name",
    "item_category":"Item Category",
    "item_brand":"Item Brand",
    "item_barcode":"Item Barcode",
    "uom_barcode":"UOM Barcode",
    "rsp":"RSP",
    "sos":"SOS",
    "shelf_level":"Shelf Level",
    "proposed_qty":"Proposed QTY",
    "top_up_qty":"Top Up QTY",
    "return_qty":"Return QTY",
    "transfer_qty":"Transfer QTY",
    "listing":"Listing",
    "stock_take_id":"Stock Take ID",
    "sheet_header_info":"Sheet Header Info",
    "visit_header_info":"Visit Header Info",
    "agent_name":"Agent Name",
    "outlet_code":"Outlet Code",
    "outlet_category":"Outlet Category",
    "outlet_chain":"Outlet Chain",
    "outlet_area":"Outlet Area",
    "calls":"Calls",
    "total_sched_month":"TOTAL SCHEDULE (ALL 1 MONTH)",
    "no_doc_dtl":"No details found",
    "user_accounts":"User Accounts",
    "no_inapp_doc":"No In-App Documents Found",
    "no_confirmed_doc":"No Confirmed Documents Found",
    "no_trans_doc":"No Transferred Documents Found",
    "no_posted_doc":"No Posted Documents Found",
    "create_selforder":"Create SelfOrder Login",
    "users":"Users",
    "create_user":"Create User",
    "user_saved":"User is created",
    "user_updated":"User is updated",
    "user_exists":"Username already exists",
    "operation_fail":"Operation Failed",
    "operation_success":"Operation Successful",
    "edit_user":"Edit User",
    "username":"username",
    "password":"Password",
    "show_password":"Show password",
    "hide_password":"Hide password",
    "old_pw":"old password",
    "new_pw":"new password",
    "notify_email":"Notify user via email",
    "user_email":"user email",
    "amend":"Amend",
    "load_ua":"Loading user accounts",
    "load_ua_failed":"Seems like there is no user in record",
    "username_error":"Username must be more than 2 characters",
    "password_error":"Password must be more than 4 characters",
    "unsafe":"Password must not contain / [ < ( ^ * | ., : ; ) > ]",
    "unsafe_username":"Username contain any special character",
    "require_cust":"You must choose a outlet",
    "chng_pw_title":"Change Password",
    "update":"UPDATE",
    "old_pw_nomatch":"Old password does not match with the username",
    "no_user_update":"Old password & new password is same",
    "invalid_email":"Invalid email address",
    "user_locked":"User is locked",
    "user_unlocked":"User is unlocked",
    "reconciliation":"Reconciliation",
    "date_from":"Date From",
    "date_to":"Date To",
    "date":"Date",
    "checked":"Checked",
    "pending":"PENDING",
    "missed":"MISSED",
    "attended":"ATTENDED",
    "reject":"Reject",
    "status":"Status",
    "no_data":"No data found",
    "invoice_list":"Invoice List",
    "debit_list":"Debit List",
    "credit_list":"Credit Note List",
    "receipt_list":"Receipt List",
    "stock":"Stock",
    "category":"Category",
    "items":"Items",
    "show_items":"Show Items",
    "show_details":"Show Details",
    "search_result":"Search Result",
    "item_dtl":"Item Details",
    "set_virtual_qty":"Set Virtual QTY (Ex: 10%)",
    "current_qty":"Current QTY",
    "avbl_qty":"Available QTY",
    "virtual_qty":"Virtual QTY",
    "customer_low":"Outlet",
    "record_updated":"Data update successful",
    "cust_dtl":"Outlet Details",
    "branches":"Branches",
    "choose_vip_item":"Choose Item For VIP QTY",
    "vip_items":"Items with VIP QTY",
    "select_item":"Please select an item",
    "app_content":"E-Info",
    "app_content2":"App Content",
    "upload_adver":"App Advertisement",
    "adver_name":"Advertisement name",
    "add_adver":"Upload a new advertisement",
    "adver_success":"Advertisement uploaded",
    "adver_fail":"Advertisement uploading failed",
    "advername_exists":"Please use another advertisement name",
    "listview":"List View",
    "gridview":"Grid View",
    "set_default":"SET DEFAULT",
    "default":"DEFAULT",
    "def_del_image":"Cannot delete default image",
    "vip_qty":"VIP QTY",
    "edit_vip":"Edit VIP QTY",
    "vip_qty_list":"VIP QTY List",
    "comment":"Comment",
    "attachments":"Attachments",
    "signed_statements":"Signed Statements",
    "event_items":"Event Items",
    "create_event":"Create Event",
    "events":"Events",
    "search_events":"Search event",
    "event_name":"Event name",
    "event_desc":"Event description",
    "event_name_inv":"Invalid event name",
    "close":"Close",
    "event_same_date":"You are going to save this event with same start and end date",
    "proceed_caps":"PROCEED",
    "newevent_created":"New event is created",
    "event_updated":"Event details is updated",
    "no_events":"No events found",
    "active":"Active",
    "inactive":"Inactive",
    "event_delete":"You are going to delete this event. All the items and rules under this event will be deleted. Do you want to proceed?",
    "search_by_month":"Search by month",
    "create_detail":"Create Segment",
    "dtl_name":"Segment name",
    "dtl_desc":"Segment details",
    "dtl_remark":"Segment remark",
    "min_qty":"Min QTY",
    "min_order_qty":"Min Order QTY",
    "edit_min_qty":"Edit Min QTY",
    "min_qty_list":"Min Order QTY List",
    "min_qty_updated":"Min QTY updated!",
    "min_qty_updated_product":"Product Min QTY updated!",
    "min_qty_failed_update":"Min QTY update failed!",
    "min_qty_deleted":"Min QTY deleted!",
    "max_qty":"Max QTY",
    "item_qty":"Item QTY",
    "min_purchase":"Min Item Purchase",
    "max_get":"Max Item Get",
    "min_price":"Min Price",
    "max_price":"Max Price",
    "adver_popup":"Advertisement Update Popup",
    "adver_old_name":"current name",
    "adver_new_name":"new name",
    "adver_image":"image",
    "chng_adver_name_title":"Change Advertisement Name",
    "adver_name_updated":"Advertisement name is updated",
    "adver_deleted":"Advertisement has been deleted",
    "no_adver_updated":"No advertisement updated",
    "active_adver":"Active",
    "inactive_adver":"Inactive",
    "show_active_adver":"Showing Active Advertisement",
    "show_inactive_adver":"Showing Inactive Advertisement",
    "failed_retrieve_adver":"Failed to retrieve advertisement",
    "add_announcement":"Upload a new announcement",
    "announcement_success":"Announcement uploaded",
    "announcement_fail":"Announcement uploading failed",
    "announcement_exists":"Please use another announcement name",
    "announcement_name":"Announcement name",
    "announcement_desc":"Announcement description",
    "announcement_same_date":"Announcement date cannot be in same date",
    "app_announcement":"App Announcement",
    "announcement_image":"Image",
    "announcement_current_name":"Current Title",
    "announcement_new_name":"New Title",
    "announcement_current_desc":"Current Description",
    "announcement_new_desc":"New Description",
    "announcement_current_datefrom":"Current Date From",
    "announcement_new_datefrom":"New Date From",
    "announcement_current_dateto":"Current Date To",
    "announcement_new_dateto":"New Date To",
    "announcement_update_dtl":"Update Announcement Details",
    "announcement_dtl":"Announcement Details",
    "announcement_info_updated":"Announcement details is updated",
    "announcement_info_not_updated":"No announcement updated",
    "announcement_success_deactivated":"Announcement successfully deactivated",
    "announcement_success_activated":"Announcement successfully activated",
    "announcement_failed_deactivated":"Failed to deactivate announcement",
    "announcement_failed_activated":"Failed to activate announcement",
    "show_active_announcements":"Showing Active Announcements",
    "show_inactive_announcements":"Showing Inactive Announcements",
    "failed_retrieve_announcements":"Failed to retrieve Announcements",
    "disable_editing_announcements":"Inactive announcements are disable for any changes",
    "activate_btn":"ACTIVATE",
    "search_item":"Search Item",
    "custom_price":"Custom Price",
    "add":"Add",
    "choose_price":"Choose Price",
    "foc":"FOC",
    "item_price":"Price",
    "sameitem_foc":"Same Item FOC",
    "lowest_foc":"Lowest Price FOC",
    "choose_states":"Choose State",
    "postage_fee":"Postage Fee",
    "payment":"Payment",
    "upload":"Upload",
    "category_img":"Upload Category Image",
    "remove_cat_image":"Remove Category Image",
    "upload_success":"Upload Successful",
    "upload_fail":"Upload Fail",
    "upload_photo":"Upload Photo",
    "select_photo_category":"Select Photo Category",
    "no_category_selected":"Please select at least one category",
    "no_image_selected":"Please select at least one image",
    "uploading":"Uploading...",
    "deleted":"Deleted!!!",
    "delete_fail":"Delete Failed",
    "available_qty":"Available QTY",
    "price":"Price",
    "qty":"Quantity",
    "edit_rec":"Edit Record",
    "agent_list":"Agent List",
    "checkin":"Check-In",
    "merchandising_checkin":"Check-In (Merchandising)",
    "promoter_checkin":"Check-In (Promoter)",
    "checkin_dtl":"Check-In Details",
    "checkout_dtl":"Check-Out Details",
    "checkin_loaded":"Check-In data found",
    "adver_status":"Advertisement status changed",
    "show_all":"Show All",
    "enter_item_name":"Enter item name",
    "create_newsubcat":"Create new segment category",
    "subcat_list":"Segment category list",
    "new_subcat":"New segment category",
    "checkin_sched":"Check-In Schedule",
    "search_agent":"Search agent",
    "appointment_time":"Appointment at",
    "note_agent":"Note for agent",
    "sel_agent":"Please select an agent",
    "schedules":"Schedules",
    "generate":"Generate",
    "picking_list":"PICKING LIST",
    "delivery_info":"Delivery Info",
    "expected_del_date":"Expected delivery date",
    "stock_transfer":"Stock Transfer",
    "stock_take":"Stock Take",
    "stock_take_list":"Stock Take List",
    "stock_take_details":"Stock Take Details",
    "backend_sync":"Backend Sync",
    "stock_template":"Stock Template",
    "chg_new_cust":"Change to new outlet",
    "chg_new_cust_cnfrm":"Are you sure you want to change to new outlet?",
    "update_doc_dtl":"Update Doc Details",
    "doc_info":"Doc Information",
    "cust_tel":"Outlet Tel No",
    "deli_add_":"Delivery Address",
    "deli_add_1":"Delivery Address 1",
    "deli_add_2":"Delivery Address 2",
    "deli_add_3":"Delivery Address 3",
    "deli_add_4":"Delivery Address 4",
    "city":"City",
    "state":"State",
    "zipcode":"Zipcode",
    "country":"Country",
    "view":"VIEW",
    "search_item_type":"Search item type",
    "item_not_exist":"ITEM DOES NOT EXIST IN RECORD",
    "create_type":"Create item type",
    "add_item":"Add new item",
    "knockoff_doc":"Knock Off Documents",
    "no_knockoff_doc":"No Knock Off document for this payment",
    "active_doc_loaded":"Active Documents loaded",
    "inactive_doc_loaded":"Inactive Documents loaded",
    "module_linkage":"Module Linkage",
    "search_sku_item":"Search SKU items",
    "b2b_client":"B2B Client",
    "b2b_client_list":"B2B Client List",
    "b2b_client_capital":"B2BCLIENT",
    "unlink_client":"UNLINK",
    "link_client":"LINK",
    "swap":"SWAP",
    "b2b_item_list":"B2B Item List",
    "search_b2b_item":"Search B2B items",
    "unlink_item":"UNLINK ITEM",
    "search_customer":"Search Outlet",
    "open_item":"Link a product",
    "room_name":"Room name",
    "room_desc":"Room description",
    "room_caseid":"Case ID",
    "open_room":"Open room",
    "sku_item_list":"SKU Item List",
    "in_range":"In Range",
    "date_range":"Pick a date range",
    "active_date_range":"Active Date Range",
    "outlet_visibility":"Outlet Visibility",
    "select_outlets":"Select outlets...",
    "all_outlets":"All Outlets",
    "visit_status":"Visit Status",
    "visited":"Visited",
    "not_visited":"Not Visited",
    "showing_all_outlets":"Showing all {count} outlets",
    "select_all_outlets":"Select All Outlets",
    "outlets_selected":"outlets selected",
    "search_outlets":"Search chains / outlets...",
    "unit_chains":"chains",
    "unit_outlets":"outlets",
    "no_date_limit":"No date limit (always active)",
    "change_status":"Make it active/inactive",
    "stock_template_items":"Stock Template Items",
    "create_new":"Create New",
    "search_stock_template":"Search stock template",
    "stock_template_name":"Stock template name",
    "newstock_template_created":"New stock template is created",
    "stock_template_updated":"Stock template details is updated",
    "stock_template_deleted":"Stock template deleted",
    "no_stock_template":"No stock template found",
    "add_stock_template_item":"Add Stock Template Items",
    "stock_template_item":"Stock Template Items",
    "individual_item":"Individual Items",
    "item_template_pkg":"Item Template/Package",
    "last_5_inv":"Last 5 Invoices",
    "item_selection":"Item Selection",
    "select_cat_here":"Select category here..",
    "select_item_here":"Select item(s) here..",
    "select_package_here":"Select package here..",
    "select_inv_item_here":"Select invoices item(s) here..",
    "remove":"REMOVE",
    "stock_template_items_added":"Stock template item(s) added",
    "inv_items":"Invoice Items",
    "package":"Package",
    "current_items":"CURRENT ITEM(S)",
    "preview_video":"Preview your video here",
    "video":"Video",
    "paste_link_here":"Paste YouTube link here..",
    "pdf":"PDF",
    "pdf_list":"PDF List",
    "preview":"Preview",
    "image":"Image",
    "pdf_uploaded":"PDF file succesfully uploaded!",
    "pdf_failed":"Failed to upload PDF file",
    "video_uploaded":"Video successfully uploaded!",
    "video_failed":"Failed to upload video",
    "not_youtube_link":"This is not YouTube link, kindly insert/paste the correct link",
    "atch_delete":"You are going to delete this attachment. Do you want to proceed?",
    "no_active_document":"No Active Document",
    "person_in_charge":"Person In Charge",
    "set_due_date":"Set Due Date",
    "manage_sched":"Manage Schedule",
    "pending_sched":"PENDING SCHEDULE",
    "time":"TIME",
    "duration":"DURATION",
    "set_time":"SPECIFIC TIME",
    "set_duration":"SPECIFIC DURATION",
    "instructions":"Any instructions/note?",
    "repeat_sched":"REPEAT SCHEDULE",
    "single_customer":"SINGLE OUTLET",
    "multiple_customer":"MULTIPLE OUTLET",
    "customer_by_area":"OUTLET BY AREA",
    "fulltext_cust":"Search by address/area/state/country",
    "pic_list":"Person In Charge List",
    "delete_recur":"Delete recurring events",
    "delete_current":"Delete current event",
    "edit_recur":"Edit recurring events",
    "edit_current":"Edit current event",
    "recur_msg":"Schedule appears in a recurring event. You can choose to make change for current event or all the same events",
    "target":"Stock Target",
    "insert_success":"Insert Success",
    "insert_fail":"Insert Failed",
    "not_found_target":"Cannot Found Target",
    "not_found_category":"Cannot Found Category",
    "not_found_item":"Cannot Found Item",
    "not_found_salesperson":"Cannot Found Agent",
    "not_found_item_target":"Cannot Found Item Target",
    "amount_empty":"Amount is empty",
    "salesperson":"Agent",
    "edit_amount":"Edit Amount",
    "date_range_check":"Please select available date, minimum 1 week",
    "target_empty":"Target name is empty",
    "insert_item":"Please insert the item",
    "insert_tag":"Please insert the tag",
    "confirm_update_request":"You want update this target details or generate as a new target? (New target will include all details in this target)",
    "submit":"Submit",
    "add_new_tg_item":"Add New Target Of Item",
    "add_new_tg_tag":"Add New Target Of Tag",
    "add_category_to_tag":"Add Category Of Tag",
    "add_new_tag":"Add New Tag",
    "confirm_update_tg":"Confirm update the target",
    "target_list":"Target List",
    "edit_tag":"Edit Tag",
    "yes":"YES",
    "no":"NO",
    "category_empty":"Category is empty",
    "confirm_insert_details":"Confirm insert this tag",
    "confirm_insert_all_details":"You want duplicate all the details in this tag?",
    "no_attr_selected":"No selected any attributes",
    "empty_tag":"Tag is empty",
    "edit":"Edit",
    "edit_quantity":"Edit Quantity",
    "edit_qty_failed":"Failed to update quantity",
    "duplicate":"Duplicate",
    "edit_target":"Edit Target",
    "new_target":"Add New Target",
    "tag":"Tag",
    "attribute":"Attribute",
    "generate_commission_report":"Generate Commission Report",
    "report":"Report",
    "nothing_save":"Nothing to save",
    "template_list":"Template List",
    "new_tmplt":"Create New Template",
    "delete_tmplt":"You are about to delete a template",
    "done":"DONE",
    "site_loc":"Site Location",
    "last_visit":"Last Visit",
    "branch":"Branch",
    "note":"Note",
    "phone_number":"Phone Number",
    "search_location":"Search Location",
    "contact_person":"Contact Person",
    "choose_project":"Projects",
    "avg_price_report":"Generate Average Price Report",
    "create_cust_grp":"Create customer group",
    "grp_of":"Group Of",
    "grp_members":"Group Members",
    "b2border":"B2B Order",
    "cash_rolling":"Cash Rolling",
    "cash_rolling_list":"Cash Rolling List",
    "amount":"Amount",
    "new_cash_rolling":"New Cash Rolling",
    "remark":"Remark",
    "cash_rolling_report":"Generate Cash Rolling Report",
    "item_link_success":"B2B item successfully linked!",
    "item_link_failed":"Failed to link B2B item!",
    "remove_customer_success":"B2B client successfully removed from the customer",
    "assign_customer_success":"B2B client successfully assigned to the customer",
    "assign_customer_failed":"Failed to assign B2B client to the customer",
    "sequence_update_success":"Sequence No. update success",
    "sequence_update_failed":"Sequence No. update failed",
    "driver_routing_report":"Generate Driver Routing Report",
    "must_push_noti":"You must enable push notification first",
    "no_modulename_found":"No module name found",
    "salesperson_list":"Agents",
    "bundle":"Bundle",
    "pwp":"PWP",
    "product":"Product",
    "new_bundle":"Add New Bundle",
    "foc_item":"FOC Items",
    "cheaper_item":"Cheaper Items",
    "out_of":"Out Of",
    "cheaper_price":"CHEAPER PRICE",
    "reportgenerator":"Report Generator",
    "transfer_doc_type_title":"Document Type when Transfer to Acc. System",
    "uom_price":"UOM Price",
    "special_price":"Special Price",
    "delivery_report":"Generate Delivery Report",
    "stock_adjustment":"Stock Adjustment",
    "dob":"Delivery On Behalf",
    "stock_transaction":"Stock Transactions",
    "voucher_report":"Voucher Redeemed Report",
    "order_report":"Order Report",
    "region":"Region",
    "stock_clearance":"Stock Clearance",
    "stock_clearance_list":"Stock Clearance List",
    "summary_report":"Summary Report",
    "doc_type":"Doc Type",
    "type":"Type",
    "teras_dashboard":"Teras Dashboard",
    "agent_attend":"Agent Attendance",
    "promoter_attend":"Promoter Attendance",
    "outlet_code":"Outlet Code",
    "stock_count":"Stock Count",
    "generate_stock_count_report":"Generate Stock Count Report",
    "outlet_category":"Outlet Category",
    "outlet_chain":"Outlet Chain",
    "outlet_area":"Outlet Area",
    "promoter_code":"Promoter Code",
    "item_code":"Item Code",
    "item_name":"Item Name",
    "product_barcode":"Product Barcode",
    "product_category":"Product Category",
    "product_brand":"Product Brand",
    "opening_stock":"Opening Stock",
    "closing_stock":"Closing Stock",
    "sell_out":"Sell Out",
    "sell_out_percentage":"Sell Out Percentage",
    "agent_name":"Agent Name",
    "promoter_name":"Promoter Name",
    "ic_number":"IC Number",
    "ic_image":"IC Image",
    "check_in_time":"Check-In Time",
    "check_out_date":"Check-Out Date",
    "check_out_time":"Check-Out Time",
    "time_spent_hour":"Time Spent (Hour)",
    "time_spent_minute":"Time Spent (Minute)",
    "checkin_coordinates":"Checkin Coordinates",
    "checkout_coordinates":"Checkout Coordinates",
    "sync_date":"Sync Date",
    "sync_time":"Sync Time",
    "outlet_visit":"Outlet Visited",
    "outlet_visit_merchandising":"Outlet Visited (Merchandising)",
    "outlet_visit_promoter":"Outlet Visited (Promoter)",
    "out_of_stock":"Out of Stock",
    "total_commission":"Total Commission",
    "total_commission_cat":"Photo Category",
    "total_commission_merchand":"Total Commission Earn By Merchandising",
    "total_st":"Total Stock Take",
    "total_photo":"Total Photo Taken",
    "total_time_spent":"Total Time Spent",
    "total_break_time":"Total Break Time",
    "stock_promotion_list":"Stock Promotion List",
    "add_stock_promotion":"Add Stock Promotion",
    "expiry_date":"Expiry Date",
    "promotion_content":"Promotion Content",
    "extend_date":"Date is already expired, please change to extend",
    "current_img":"Current Image",
    "product_name":"Product Name",
    "controller":"Controller",
    "operation":"Operation",
    "insight":"Insight",
    "merchandising":"Merchandising",
    "promoter":"Promoter",
    "promoter_photo_categories":"Promoter Photo Categories",
    "new_photo_category":"New Photo Category",
    "edit_photo_category":"Edit Photo Category",
    "category_name":"Category Name",
    "this_month":"This Month",
    "location":"location",
    "st_report":"Stock Take Report",
    "clear_all_data":"Clear All Data",
    "confirm_clear":"Are you sure you want to delete all the records for the selected location ?",
    "confirm":"Confirm",
    "route_id":"Route ID",
    "drivers":"Drivers",
    "assistant":"Assistant",
    "generate_type":"Generate As",
    "product_uom":"Product UOM",
    "product_desc":"Product Description",
    "barcode":"Barcode",
    "update_success":"Update Successful",
    "update_fail":"Update Failed",
    "new_uom":"Add New Product UOM",
    "edit_uom":"Edit Product UOM",
    "product_code":"Product Code",
    "edit_product_name":"Edit Product Name",
    "outlet_name":"Outlet Name",
    "address1":"Address 1",
    "address2":"Address 2",
    "longitude":"Longitude",
    "latitude":"Latitude",
    "cust_code":"Outlet Code",
    "add_customer":"Add New Outlet",
    "edit_customer":"Edit Customer",
    "out_no_record":"Outlet Visit No Record",
    "oos_no_record":"Out of Stock No Record",
    "comm_no_record":"TotalCommission Merchandising No Record",
    "comc_no_record":"Total Commission Categories No Record",
    "st_no_record":"Total Stock Take No Record",
    "photo_no_record":"Photo Taken No Record",
    "time_no_record":"Total Time Spent No Record",
    "uom":"UOM",
    "new_product":"New Product",
    "active_product":"Active Product",
    "inactive_product":"Inactive Product",
    "add_uom":"Add UOM",
    "delete_uom":"Delete UOM",
    "uomrate":"Rate",
    "schedule_status":"Schedule Status",
    "generate_agent_attend_report":"Generate Agent Attendance Report",
    "generate_stock_take_report":"Generate Stock Take Report",
    "generate_oos_report":"Generate OOS Report",
    "generate_outlet_visit_report":"Generate Outlet Visit Report",
    "generate_outlet_visit_frequency_report":"Generate Outlet Visited Frequency Report",
    "generate_schedule_visit_report":"Generate Scheduled Visit Report",
    "generate_stock_near_expiry_date_report":"Generate Stock Near Expiry Date Report",
    "all":"All",
    "oos":"Out Of Stock",
    "schedule_visit":"Schedule Visit",
    "stock_near_expiry":"Stock Near Expiry",
    "stock_near_expiry_analysis_by_item":"Stock Near Expiry By Item",
    "outlet_visit_frequency":"Outlet Visit Frequency",
    "brand":"Brand",
    "add_brand":"Add New Brand",
    "edit_brand":"Edit Brand",
    "category_list":"Category Item List",
    "brand_list":"Brand Item List",
    "category_code":"Category Code",
    "category_name":"Category Name",
    "new_category":"New Category",
    "category_details":"Category Details",
    "brand_details":"Brand Details",
    "category_info":"Category Information",
    "brand_info":"Brand Information",
    "new_category_item":"Add New Category Items",
    "new_brand_item":"Add New Brand Items",
    "update_fail_brand":"Update Failed. Brand Code is Existed",
    "update_fail_category":"Update Failed. Category Code is Existed",
    "brand_img":"Upload Brand Image",
    "remove_brand_image":"Remove Brand Image",
    "cust_category_code":"Outlet Category Code",
    "cust_category_name":"Outlet Category Name",
    "cust_chain_code":"Outlet Chain Code",
    "cust_chain_name":"Outlet Chain Name",
    "new_cust_chain":"New Outlet Chain",
    "new_cust_category":"New Outlet Category",
    "cust_category_list":"Category Outlet List",
    "cust_chain_list":"Chain Outlet List",
    "cust_chain":"Outlet Chain",
    "cust_category":"Outlet Category",
    "cust_category_details":"Outlet Category Info",
    "cust_chain_details":"Outlet Chain Info",
    "update_fail_cust_category":"Update Failed. Customer Category Code is Existed",
    "update_fail_cust_chain":"Update Failed. Customer Chain Code is Existed",
    "template_item_list":"Template Item List",
    "compulsory":"Compulsory",
    "compulsory_survey_hint":"Agents must complete this survey before proceeding",
    "partially":"Partially",
    "brand_code":"Brand Code",
    "brand_name":"Brand Name",
    "new_brand":"New Brand",
    "mileage": "Mileage",
    "user_settings": "User Settings",
    "user_details": "User Details",
    "email": "Email",
    "contact_no": "Contact No.",
    "name": "Name",
    "login": "Login",
    "login_tagline": "Empower Your Field Team With Real-Time Insights",
    "login_subtitle": "Monitor outlet visits, track KPI performance, and optimize your merchandising and sales execution.",
    "login_feature_1": "Live GPS check-in & route tracking",
    "login_feature_2": "Real-time KPI & call rate dashboard",
    "login_feature_3": "Photo reporting with timestamp",
    "login_feature_4": "Promotion & stock visibility",
    "login_trusted_by": "Trusted by 50+ B2B Brands & Distributors",
    "login_portal_title": "Back Office Portal",
    "login_portal_subtitle": "Field Force Automation Platform",
    "login_access_dashboard": "Access Dashboard",
    "login_remember_me": "Remember me",
    "login_check_username": "Check your username",
    "login_check_password": "Check your password",
    "login_network_error": "Network error, please try again",
    "network_error": "Network error, please try again",
    "resigning": "Resigning User",
    "resign_user": "Resign User",
    "resign_user_confirm1": "Are you sure to resign this user?",
    "resign_user_confirm2": "If yes, please select another user for replacement.",
    "user_access_regions": "User Access Regions",
    "regions_no_data": "No region access for this user.",
    "position": "Position",
    "staff_code": "Staff Code",
    "user_role": "User Role",
    "manager": "Manager",
    "refresh": "Refresh",
    "view_columns": "View Columns",
    "users_shown": "@shown of @total users",
    "no_role_assigned": "No role is assigned to this user.",
    "user_group": "User Group",
    "no_group_found": "No group found under this user.",
    "user_outlet_details": "User Outlet Details",
    "user_outlet_list": "User Outlet List",
    "photo_gallery": "Photo Gallery",
    "promoter_photo_category": "Photo Gallery",
    "promotion": "Promotion",
    "promotion_types": "Promotion Types",
    "promotion_type_name": "Type Name",
    "active_promo": "Active Promo",
    "new_promotion_type": "New Promotion Type",
    "edit_promotion_type": "Edit Promotion Type",
    "promotion_type_delete": "You are going to delete this promotion type. Do you want to proceed?",
    "enter_promotion_type_name": "Please enter Type Name",
    "no_promotion_types": "No promotion types yet",
    "promotion_types_empty_hint": "Create your first type to categorize promotions.",
    "promo_list":"Promo List",
    "new_promotion":"New Promotion",
    "edit_promotion":"Edit Promotion",
    "promotion_details":"Promotion Details",
    "skus_in_promotion":"SKUs in Promotion",
    "applicable_outlets":"Applicable Outlets",
    "compliance_tasks":"Compliance Tasks",
    "normal_price":"Normal Price",
    "promo_price":"Promo Price",
    "start_date":"Start Date",
    "end_date":"End Date",
    "task_start_date":"Task Start Date",
    "task_due_date":"Task Due Date",
    "task_description":"Task Description",
    "input_type":"Input Type",
    "applies_to":"Applies To",
    "all_skus":"All SKUs",
    "specific_skus":"Specific SKUs",
    "reference_photo":"Reference Photo",
    "required":"Required",
    "save_draft":"Save Draft",
    "publish":"Publish",
    "published":"Published",
    "upcoming":"Upcoming",
    "draft":"Draft",
    "discard":"Discard",
    "view_report":"View Report",
    "coming_soon":"Coming soon",
    "notify":"Notify",
    "tasks_unit":"tasks",
    "outlets_unit":"outlets",
    "all_brands":"All Brands",
    "all_months":"All Months",
    "select_chains":"Step 1 — Select Chains",
    "pick_outlets":"Step 2 — Pick Outlets",
    "selected_outlets":"Selected Outlets",
    "no_outlets_selected":"No outlets selected yet",
    "outlets_selected_count":"outlets selected",
    "add_sku":"Add SKU",
    "add_task":"Add Task",
    "select_brand_first":"Select a brand first",
    "sku_already_added":"This SKU is already in the list",
    "change_brand_confirm":"Changing brand will clear the SKU list. Continue?",
    "unsaved_changes_confirm":"You have unsaved changes. Discard them?",
    "delete_promotion_confirm":"Delete this promotion?",
    "promo_price_warning":"Promo price is not lower than normal price",
    "task_notify_hint":"Task start date is the notification date. Push notification opens in the next phase.",
    "task_due_hint":"Task due date must be before the promotion start date.",
    "publish_success":"Promotion published",
    "draft_saved":"Draft saved",
    "no_promotions":"No promotions yet",
    "promotions_empty_hint":"Create your first promotion to assign SKUs, outlets and compliance tasks.",
    "err_name_required":"Promotion name is required",
    "err_brand_required":"Brand is required",
    "err_dates_required":"Start and end dates are required",
    "err_date_order":"Start date must be before end date",
    "err_min_one_sku":"Add at least one SKU",
    "err_promo_price_required":"Every SKU needs a promo price",
    "err_min_one_outlet":"Select at least one outlet",
    "err_min_one_task":"Add at least one task",
    "err_task_desc_required":"Every task needs a description",
    "err_task_skus_required":"Specific SKU tasks must select at least one SKU",
    "err_task_dates_required":"Task start and due dates are required",
    "err_task_date_order":"Task start date must be before task due date",
    "err_task_due_before_start":"Task due date must be before the promotion start date",
    "promotion_name":"Promotion Name",
    "select_all":"Select All",
    "text":"Text",
    "number":"Number",
    "checkbox":"Checkbox",
    "photo":"Photo",
    "expired":"Expired",
    "month":"Month",
    "action": "Action",
    "confirmation": "Confirmation",
    "check_all":"Check All",
    "all_day": "All Day",
    "due_date":"Due Date",
    "incentive": "Promoter Incentive",
    "stock_level_tooltip": "Enable/disable Stock Level",
    "stock_level_settings": "Set stock level thresholds",
    "stock_level_set_title": "Set stock level thresholds",
    "stock_level_set_desc": "Enter how many units each level represents for this product.",
    "stock_level_low": "Low",
    "stock_level_medium": "Medium",
    "stock_level_high": "High",
    "stock_level_units": "units",
    "stock_level_eg": "e.g.",
    "stock_level_qty_updated": "Stock level quantities updated",
    "stock_level_qty_failed": "Failed to update stock level quantities",
    "unsched_outlet_visit": "Unscheduled Outlet Visit",
    "uncheduled": "UNSCHEDULED",
    "cancelled": "CANCELLED",
    "copy_user": "Copy User",
    "copy_user_confirm1": "Copying will replace opponet existing data, please choose carefully.",
    "copy_user_confirm2": "If you have made up your mind, please select which user for replacement.",
    "competitor_price_checking": "Competitor Price Check",
    "competitor": "Competitor",
    "edit_competitor": "Edit Competitor",
    "add_competitor": "Add Competitor",
    "competitor_code": "Competitor Code",
    "competitor_name": "Competitor Name",
    "description": "Description",
    "competitor_details": "Competitor Details",
    "competitor_products": "Competitor Products",
    "competitor_product_category": "Competitor Product Category",
    "add_product": "Add Product",
    "add_category": "Add Category",
    "competitor_product_details": "Competitor Product Details",
    "edit_product": "Edit Product",
    "competitor_category_details": "Competitor Category Details",
    "category_products": "Category Products",
    "assign_product": "Assign Product",
    "edit_category": "Edit Category",
    "missedwreason": "MISSED W/REASON",
    "frequency_list": "Frequency List",
    "posm": "POSM",
    "checklist": "CHECKLIST",
    "agent_attend_insight": "Agent Attendance Insight",
    "outlet_visit_insight": "Outlet Visited Insight",
    "area": "Area",
    "rdisplay": "Display %",
    "rsku": "SKU %",
    "new_batch_no": "New Batch No",
    "batch_no": "Batch No",
    "show_inactive_batch": "Show Inactive Batch",
    "show_active_batch": "Show Active Batch Only",
    "show_inactive_barcode": "Show Inactive Barcode",
    "show_active_barcode": "Show Active Barcode Only",
    "outlet_visit_analysis": "Outlet Visit Analysis",
    "chain": "Chain",
    "item_chain_code": "Item Chain Code",
    "item_chain_code_list": "Item Chain Code List",
    "new_item_chain_code": "New Item Chain Code",
    "edit_item_chain_code": "Edit Item Chain Code",
    "select_chain": "Select Chain",
    "select_uom": "Select UOM",
    "field_required": "is required",
    "barcode_list": "Barcode List",
    "new_barcode": "New Barcode",
    "edit_barcode": "Edit Barcode",
    "table_analysis_report": "Table Analysis Report",
    "rCompetitorPriceCheck": "Competitor Price Check",
    "rCompetitorPriceCheckAnalysis": "Competitor Price Check Analysis",
    "cust_type": "Outlet Type",
    "cust_type_list": "Type Outlet List",
    "cust_type_code": "Outlet Type Code",
    "cust_type_name": "Outlet Type Name",
    "cust_type_details": "Outlet Type Info",
    "update_fail_cust_type":"Update Failed. Customer Type Code is Existed",
    "new_cust_type":"New Outlet Type",
	  "cust_area": "Outlet Area",
	  "new_cust_area":"New Outlet Area",
	  "cust_area_code": "Outlet Area Code",
    "cust_area_name": "Outlet Area Name",
    "cust_area_details": "Outlet Area Info",
    "tutorials": "Tutorials",
    "tutorial_library_subtitle": "Find the right walkthrough and learn at your own pace.",
    "tutorial_search_placeholder": "Search tutorials",
    "tutorial_video_count": "videos",
    "tutorial_watch": "Watch tutorial",
    "tutorial_load_failed": "Failed to load tutorials",
    "tutorial_retry": "RETRY",
    "system_settings":"System Settings",
    "photo_type": "Photo Type",
    "photo_taken_analysis": "Photo Taken Analysis",
    "photo_taken": "Photo Taken",
    "google_location_tracking": "Google Location Tracking",
    "download": "Download",
    "downloading": "Downloading...",
    "download_success": "Download success",
    "download_failed": "Download failed",
    "item_distribution_analysis": "Item Distribution By Item",
    "item_distribution_analysis_by_agent": "Item Distribution By Agent",
    "stock_near_expiry_analysis" : "Stock Near Expiry Analysis",
    "export_template":"Export Template",
    "export":"Export",
    "import_csv":"Import .CSV",
    "bulk_import_new": "New",
    "bulk_import_update": "Update",
    "bulk_import_status": "Status",
    "bulk_import_inserted": "inserted",
    "bulk_import_updated": "updated",
    "bulk_import_check_error": "Failed to check existing outlets",
    "bulk_import_network_error": "Network error",
    "stock_near_expiry_analysis_by_day": "Stock Near Expiry Analysis (By Day)",
    "survey_form": "Form",
    "csr_activity": "CSR Activity",
    "survey_response": "Form Response",
    "survey_title": "Survey Title",
    "submission_date": "Submission Date",
    "check_in": "Check In",
    "check_out": "Check Out",
    "photo_viewer_drag_hint": "Drag to move or use direction controls",
    "survey_response_details": "Survey Response Details",
    "download_pdf": "Download as PDF",
    "no_answer": "No answer",
    "no_image_available": "No image available",
    "question_abbr": "Q",
    "qtype_text": "Text",
    "qtype_rating": "Rating",
    "qtype_choice": "Multiple Choice",
    "qtype_photos": "Photos",
    "column_layout_saved": "Column layout saved",
    "column_layout_save_failed": "Failed to save column layout",
    "manage_users": "Manage Users",
    "user_management": "User Management",
    "user_account": "User Account",
    "active_user_quota": "Active User Quota Usage",
    "quota_exceeded": "Active user quota has been reached",
    "user_exists_active": "This username is in use",
    "name_label": "Name",
    "is_required": "is required",
    "personal": "Personal",
    "working_time": "Working Time",
    "bank_details": "Bank Details",
    "ic_no": "IC",
    "address": "Address",
    "start_time": "Start Time",
    "end_time": "End Time",
    "rest_day": "Rest Day",
    "select_rest_day": "Select Rest Day",
    "repeats_every": "Repeats every",
    "rest_start_date": "Start Date",
    "rest_start_date_required": "Please select start date",
    "branch_required": "Please select branch",
    "week": "week",
    "bank_name": "Bank Name",
    "bank_account_number": "Bank Account Number",
    "bank_account_name": "Bank Account Name",
    "edit_user": "Edit User",
    "select_role": "Select Role",
    "sun": "Sun",
    "mon": "Mon",
    "tue": "Tue",
    "wed": "Wed",
    "thu": "Thu",
    "fri": "Fri",
    "sat": "Sat",
    "password_changed": "Password has been changed",
    "user_activated": "User has been activated",
    "user_deactivated": "User has been deactivated",
    "created_date": "Created Date",
    "inactive_date": "Inactive Date",
    "last_updated_date": "Last Updated",
    "by": "by",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "account_info": "Account",
    "optional": "Optional",
    "no_limit": "No limit",
    "check_in_date": "Check In Date",
    "places": "Places",
    "agent_code": "Agent Code",
    "checkin_settings": "Check In",
    "checkin_settings_subtitle": "Set up the check-in requirements for representatives.",
    "checkin_selfie_mandatory": "Check-in, Check-out Image Mandatory",
    "checkin_selfie_desc": "If turned on, agent needs to take a selfie before proceeding to check-in and check-out.",
    "limit_checkin_radius": "Limit Check-in Radius",
    "limit_checkin_radius_desc": "If turned on, agent can only check-in when they are within radius below of their current location.",
    "minimum_radius_note": "Note: 300 meters is the minimum radius that should be set.",
    "limit_checkout_radius": "Limit Check-out Radius",
    "limit_checkout_radius_desc": "If turned on, agent can only check-out within the radius of their current location.",
    "radius_setting": "Radius setting",
    "feedback": "Feedback",
    "feedback_title": "Feedback Title",
    "feedback_listing": "Feedback Listing",
    "announcement":"Announcement",
    "announcement_compose":"Compose",
    "announcement_manage":"Manage",
    "announcement_inbox":"Inbox",
    "announcement_title":"Title",
    "announcement_content":"Content",
    "announcement_attachments":"Attachments",
    "announcement_youtube_url":"YouTube / Video URL",
    "announcement_youtube_invalid":"Invalid link",
    "announcement_add":"Add",
    "announcement_audience":"Audience",
    "announcement_all_clients":"All Clients",
    "announcement_recipients":"Recipients",
    "announcement_priority":"Priority",
    "announcement_priority_info":"Info",
    "announcement_priority_important":"Important",
    "announcement_publish_date":"Publish Date",
    "announcement_publish_date_hint":"Leave empty to publish immediately",
    "announcement_save_draft":"Save Draft",
    "announcement_publish":"Publish",
    "announcement_published":"Published",
    "announcement_draft":"Draft",
    "announcement_drafts":"Drafts",
    "announcement_all":"All",
    "announcement_unread":"Unread",
    "announcement_read_rate":"Read",
    "announcement_actions":"Actions",
    "announcement_retract":"Retract",
    "announcement_retract_confirm":"Retract this announcement? It will disappear from all client inboxes and move back to Draft.",
    "announcement_delete_confirm":"Delete this draft? This cannot be undone.",
    "announcement_select_to_read":"Select an announcement to read",
    "announcement_no_data":"No announcements yet",
    "announcement_notifications":"Notifications",
    "announcement_no_unread":"You're all caught up",
    "announcement_new_popup_title":"New Announcement",
    "announcement_new_popup_desc":"You have unread announcements from EasyM:",
    "announcement_view":"View",
    "announcement_add_image":"+ Image",
    "announcement_add_video":"+ Video",
    "announcement_add_pdf":"+ PDF",
    "announcement_add_youtube":"Video Link",
    "announcement_users":"users",
    "announcement_specific_users":"Specific Users (Optional)",
    "announcement_all_users_in_clients":"All Users",
    "announcement_priority_critical":"Critical",
    "announcement_file_too_large":"File exceeds 50MB",
    "announcement_too_many_files":"Maximum 10 attachments",
    "announcement_file_type_invalid":"Unsupported file type",
    "feedback_detail": "Feedback Detail",
    "feedback_status_pending_resolve": "Pending Resolve",
    "feedback_status_resolved": "Resolved",
    "feedback_description": "Description",
    "feedback_images": "Images Uploaded",
    "feedback_update": "Update Feedback",
    "feedback_add_title": "Add Feedback Title",
    "feedback_active_filters": "Active Filters",
    "feedback_results": "results",
    "feedback_confirm_status": "Update status to",
    "feedback_status_updated": "Status updated to",
    "working_shift": "Working Shift",
    "shift_name": "Shift Name",
    "start_time": "Start Time",
    "end_time": "End Time",
    "payout": "Payout",
    "total_hours": "Total Hours",
    "add_working_shift": "Add Working Shift",
    "edit_working_shift": "Edit Working Shift",
    "action": "Action",
    "undo": "UNDO",
    "leaves": "Leaves",
    "leaves_listing": "Leaves Listing",
    "leave_type": "Leave Type",
    "leave_type_desc": "Manage leave types available to staff.",
    "leave_types": "Leave Types",
    "leave_type_code": "Type Code",
    "leave_type_name": "Type Name",
    "add_leave_type": "Add Leave Type",
    "edit_leave_type": "Edit Leave Type",
    "reason_required": "Reason Required",
    "attachment_required": "Attachment Required",
    "apply_date": "Apply Date",
    "leave_days": "Days",
    "leave_from": "From",
    "leave_to": "To",
    "session_am": "Morning",
    "session_pm": "Afternoon",
    "leave_reason": "Reason",
    "agent": "Agent",
    "approved": "Approved",
    "rejected": "Rejected",
    "approved_by": "Approved By",
    "approved_date": "Approved Date",
    "rejected_by": "Reject By",
    "rejected_date": "Reject Date",
    "reject_reason": "Reject Reason",
    "reject_reason_required": "Please enter reject reason",
    "leave_name_required": "Please enter the name",
    "generate_report": "Generate Report",
    "generating_report_loading": "Generating Report...",
    "leave_confirm_status": "Update leave status to",
    "leave_status_updated": "Leave status updated to",
    "outlet_code_desc": "Outlet code auto-generation rules (read-only).",
    "next_running_no": "Next Running No.",
    "reference_no": "Reference No.",
    "code_format": "Code Format",
    "photo_type_desc": "Manage photo categories. Drag to reorder, then publish.",
    "photo_type_v2_desc": "Organize photo groups and types, then publish their display order.",
    "feedback_title_desc": "Manage the title options used by the feedback form in the app.",
    "promoter_photo_categories_desc": "Manage photo categories available to promoters.",
    "working_shift_desc": "Define working shifts used by scheduling.",
    "publish_sequence": "Publish Order",
    "modified": "Modified",
    "reset": "Reset",
    "filter_table": "Filter Table",
    "saved": "Saved",
    "commission": "Commission",
    "name_required": "Name cannot be blank.",
    "required_fields": "Please fill in all required fields.",
    "max_photo_error": "Max Photo must be greater than 0.",
    "min_photo_error": "Min Photo cannot be greater than Max Photo.",
    "breadcrumb": "Breadcrumb",
    "root": "Root",
    "reorder": "Reorder",
    "gallery_group": "Gallery Group",
    "min_photo": "Min Photo",
    "max_photo": "Max Photo",
    "group_type": "Group / Type",
    "qty_needed": "QTY Needed",
    "code": "Code",
    "group": "Group",
    "inactivate_outlet":"Inactivate Outlet",
    "outlet_tied_to_schedule":"Outlet is tied to a merchandiser schedule",
    "outlet_scheduled_visits":"is currently scheduled for the following visit(s):",
    "appointment":"Appointment",
    "visit_schedule":"Visit Schedule",
    "visits":"visit(s)",
    "next":"next",
    "inactivate_remove_schedule_warning":"Inactivating will automatically remove it from the schedule(s) above. This cannot be undone — you will need to re-schedule after re-activating.",
    "inactivate_outlet_confirm":"Are you sure you want to inactivate this outlet?",
    "inactivate_and_remove":"Inactivate & Remove",
    "inactivate":"Inactivate",
    "activate_outlet":"Activate Outlet",
    "activate_outlet_confirm":"Are you sure you want to activate this outlet?",
    "activate":"Activate",
    "audit_trail":"Audit Trail",
    "timestamp":"Timestamp",
    "performed_by":"User",
    "role_admin":"Admin",
    "ip_address":"IP Address",
    "record_id":"Record ID",
    "all_actions":"All Actions",
    "all_users":"All Users",
    "action_create":"Add Outlet",
    "action_update":"Edit Outlet",
    "action_active":"Set Active",
    "action_inactive":"Set Inactive",
    "field_changes":"Field Changes",
    "value_before":"Before",
    "value_after":"After",
    "reason_note":"Reason / Note",
    "reason_required":"Reason is required",
    "no_matching_events":"No matching events",
    "no_matching_events_hint":"Try adjusting the filters or date range above.",
    "audit_legacy_record":"This record predates the activity log feature — user and IP were not captured.",
    "audit_system_user":"System",
    "audit_no_field_changes":"No field-level changes recorded for this event type",
    "address_2":"Address 2",
    "updated_by":"Updated By",
    "created_by":"Created By",
    "created_date":"Created Date",
    "company":"Company",
    "action_assign":"Assign User",
    "action_unassign":"Unassign User",
    "assigned_user":"Assigned User",
    "audit_source":"Source",
    "audit_src_outlet_detail":"Outlet Details - Agents",
    "audit_src_outlet_create":"Add Outlet",
    "audit_src_outlet_edit":"Edit Outlet",
    "audit_src_user_outlet":"User Settings - Outlets",
    "audit_src_resign":"User Settings - Resign",
    "audit_src_copy":"User Settings - Copy Outlet",
    "audit_src_checkin_approve":"Check-in Approval",
    "attachment":"Attachment",
    "upload_attachment":"Upload Attachment",
    "uploaded_by":"Uploaded By",
    "uploaded_on":"Uploaded On",
    "file_size":"Size",
    "files":"files",
    "no_attachments_yet":"No attachments yet",
    "no_attachments_hint":"Upload contracts, documents or any file for this user.",
    "drag_drop_hint":"Drag & drop a file here, or",
    "browse":"browse",
    "max_file_size_hint":"Any file · Max 10 MB",
    "file_too_large":"File exceeds the 10 MB limit",
    "attachment_uploaded":"Attachment uploaded",
    "attachment_deleted":"Attachment deleted",
    "delete_attachment_title":"Delete attachment?",
    "delete_attachment_message":"will be removed from this user. This can't be undone.",
    "remark_optional":"Remark (optional)",
    "zoom_in":"Zoom in",
    "zoom_out":"Zoom out",
    "rotate_left":"Rotate left",
    "rotate_right":"Rotate right",
    "save_rotation":"Save",
    "rotation_saved":"Image saved successfully",
    "rotation_failed":"Failed to save image",
    "drag_to_move_hint":"Drag to move or use direction controls",
    "open_in_new_tab":"Open in new tab",
    "previous_file":"Previous",
    "next_file":"Next",
    "preview_failed":"Failed to load preview",
    "showing_first_rows":"Showing first rows:",
    "loading":"Loading...",
  },
  "zh":{
    "dashboard":"仪表板",
    "outlet_coverage":"网点覆盖",
    "called_rate":"拜访达成率",
    "team_efficiency":"团队效率",
    "assigned":"已分配",
    "scheduled":"已排程",
    "coverage":"覆盖率",
    "summary_by_area":"区域汇总",
    "summary_by_agent":"业务员汇总",
    "vs_last_month":"对比上月",
    "vs":"对比",
    "graph_period":"图表期间",
    "table_period":"表格期间",
    "overview":"总览",
    "oos_count":"缺货次数",
    "outlets":"网点",
    "products_affected":"受影响产品",
    "summary_by_product":"产品汇总",
    "from_master_list":"来自门店主名单",
    "from":"从",
    "to":"到",
    "attended_label":"完成",
    "unassigned":"未分配",
    "transaction":"交易",
    "monthly_sales":"每月销售",
    "semiannual_sales":"半年度销售",
    "logout":"登出",
    "top_salesman":"最佳推销员",
    "top_customer":"最佳顾客",
    "sales":"销售量",
    "outstanding":"未付金额",
    "top_items":"最佳物品",
    "total":"总额",
    "es_backend":"EASYM",
    "proceed_logout":"您正在注销。通过注销，系统将清除缓存数据，包括主题，语言，选择的搜索条件等。您可以在下次登录时重新设置它们。",
    "logout_cap":"登出",
    "cancel":"取消",
    "search_anything":"搜索任何东西",
    "search":"搜索。。。",
    "search_cap":"搜索",
    "clear":"清除",
    "delete":"删除",
    "selected":"已选",
    "total_selected":"已选择",
    "no_matches_found":"未找到匹配项",
    "try_different_keyword":"试试其他关键词",
    "settings":"设定",
    "save":"保存",
    "rows_per_page":"每页行",
    "table_info":"交易表信息",
    "search_crit":"条件搜索",
    "today":"今天",
    "yesterday":"昨天",
    "last_week":"过去一周",
    "last_month":"过去一个月",
    "choose_date":"选择日期",
    "doc_date":"文件日期",
    "del_date":"邮寄日期",
    "ok":"好的",
    "active_doc":"有效文件",
    "inactive_doc":"无效文件",
    "pending_doc":"待定文件",
    "salesman":"推销员",
    "customer":"客户",
    "cust_list":"客户列表",
    "cust_not_in_list":"名单外客户",
    "no_internet":"您没有连接互联网",
    "doc_details":"文件明细",
    "active_doc_done":"应用内文档已加载",
    "confirm_doc_done":"确认文件已加载",
    "trans_doc_done":"转移文件已加载",
    "posted_doc_done":"文件上載成功",
    "doc_dtl_fail":"文件明细加载失败",
    "inapp_doc":"应用内文件",
    "confirmed_doc":"确认文件",
    "trans_doc":"转移文件",
    "posted_doc":"已上載文件",
    "reset_selection":"重置",
    "export_column_settings":"导出列设置",
    "product_info_columns":"产品信息列",
    "stock_data_columns":"盘点数据列(每次盘点)",
    "item_code":"产品代码",
    "item_name":"产品名称",
    "item_category":"产品类别",
    "item_brand":"产品品牌",
    "item_barcode":"产品条码",
    "uom_barcode":"单位条码",
    "rsp":"RSP",
    "sos":"SOS",
    "shelf_level":"货架层",
    "proposed_qty":"建议数量",
    "top_up_qty":"补货数量",
    "return_qty":"退货数量",
    "transfer_qty":"调货数量",
    "listing":"上市状态",
    "stock_take_id":"盘点单号",
    "sheet_header_info":"表头信息",
    "visit_header_info":"拜访标题信息",
    "agent_name":"销售员名字",
    "outlet_code":"客户代码",
    "outlet_category":"客户类别",
    "outlet_chain":"客户连锁",
    "outlet_area":"客户区域",
    "calls":"拜访",
    "total_sched_month":"本月总排程",
    "no_doc_dtl":"没找到文件明细",
    "user_accounts":"用户账号",
    "no_inapp_doc":"找不到应用内文件",
    "no_confirmed_doc":"找不到确认文件",
    "no_trans_doc":"找不到转移文件",
    "no_posted_doc":"找不到已上載文件",
    "create_selforder":"创建登录自我下单",
    "users":"用户",
    "create_user":"创建用户",
    "user_saved":"用户已创建",
    "user_updated":"用户已更新",
    "user_exists":"用户已存在",
    "operation_fail":"运作失败",
    "operation_success":"Operation Successful",
    "edit_user":"编辑用户 ",
    "username":"用户名",
    "password":"密码",
    "show_password":"显示密码",
    "hide_password":"隐藏密码",
    "old_pw":"旧密码",
    "new_pw":"新密码",
    "notify_email":"通过电子邮件通知用户",
    "user_email":"用户电子邮件",
    "amend":"修改",
    "load_ua":"用户账户加载中",
    "load_ua_failed":"似乎没有用户记录",
    "username_error":"用户名必须多过两个字符",
    "password_error":"密码必须多过四个字符",
    "unsafe":"用户名和密码不可以包含任何特殊字符",
    "unsafe_username":"用户名包含了任何特殊字符",
    "require_cust":"你必须选择一个客户",
    "chng_pw_title":"更改密码",
    "update":"更新",
    "old_pw_nomatch":"旧密码与用户名不匹配",
    "no_user_update":"旧密码和新密码是一样的",
    "invalid_email":"无效电子邮件",
    "user_locked":"用户已被锁定",
    "user_unlocked":"用户已经解锁",
    "reconciliation":"和解",
    "date_from":"日期从",
    "date_to":"到日期",
    "checked":"已检查",
    "pending":"待定",
    "missed":"错过",
    "attended":"完成",
    "status":"状态",
    "reject":"拒绝",
    "no_data":"没有找到数据",
    "invoice_list":"发票列表",
    "debit_list":"借方清单",
    "credit_list":"信贷清单",
    "receipt_list":"收据清单",
    "stock":"库存",
    "category":"类别",
    "items":"物品",
    "show_items":"显示物品",
    "show_details":"显示详细",
    "search_result":"显示结果",
    "item_dtl":"物品明细",
    "set_virtual_qty":"设置虚拟数量（例如：10％）",
    "current_qty":"当前数量",
    "avbl_qty":"可用数量",
    "virtual_qty":"虚伪数量",
    "customer_low":"客户",
    "record_updated":"数据更新成功",
    "cust_dtl":"客户明细",
    "branches":"分行",
    "choose_vip_item":"选择贵宾数量的物品",
    "vip_items":"贵宾数量的物品",
    "select_item":"请选择一个物品",
    "app_content":"电子资讯",
    "app_content2":"程序內容",
    "upload_adver":"程序廣告",
    "adver_name":"廣告名稱",
    "add_adver":"上載新的廣告",
    "adver_success":"廣告上載成功",
    "adver_fail":"廣告上載失敗",
    "advername_exists":"請使用別的廣告名稱",
    "listview":"列表視圖",
    "gridview":"網格視圖",
    "set_default":"設置成默認",
    "default":"默認",
    "def_del_image":"無法刪除默認圖片",
    "vip_qty":"VIP數量",
    "edit_vip":"設定VIP數量",
    "vip_qty_list":"贵宾数量列表",
    "comment":"評論",
    "attachments":"附件",
    "signed_statements":"簽署聲明",
    "event_items":"活动项目",
    "create_event":"创建活动",
    "events":"活动",
    "search_events":"搜寻活动",
    "event_name":"活动名称",
    "event_desc":"活动描述",
    "event_name_inv":"活动名称无效",
    "close":"关闭",
    "event_same_date":"你将使用相同的开始日期和结束日期保持该活动",
    "proceed_caps":"继续",
    "newevent_created":"已创建新的活动",
    "no_events":"找不到该活动",
    "active":"有效",
    "inactive":"无效",
    "event_updated":"活动详细信息已更新",
    "event_delete":"你将要删除该活动。此活动下的所有货品和规则将会被删除。您要继续吗？",
    "search_by_month":"以月份搜索",
    "create_detail":"创建分类",
    "dtl_name":"分类名称",
    "dtl_desc":"分类描述",
    "dtl_remark":"分类备注",
    "min_qty":"最低数量",
    "min_order_qty":"最低订购数量",
    "edit_min_qty":"更改最低数量",
    "min_qty_list":"最低订购数量列表",
    "min_qty_updated":"最低数量已更新！",
    "min_qty_updated_product":"产品最低数量已更新！",
    "min_qty_failed_update":"最低数量更新失败！",
    "min_qty_deleted":"最低数量已删除",
    "max_qty":"最大数量",
    "adver_popup":"广告更新窗口",
    "adver_old_name":"现名",
    "adver_new_name":"新名字",
    "adver_image":"图片",
    "chng_adver_name_title":"更改广告名称",
    "adver_name_updated":"广告名称已更新",
    "adver_deleted":"广告已删除",
    "no_adver_updated":"没有广告更新",
    "active_adver":"有效",
    "inactive_adver":"无效",
    "show_active_adver":"显示有效广告",
    "show_inactive_adver":"显示无效的广告",
    "failed_retrieve_adver":"检索广告失败",
    "add_announcement":"上载新公告",
    "announcement_success":"公告已上传",
    "announcement_fail":"公告上传失败",
    "announcement_exists":"请使用其他公告名称",
    "announcement_name":"公告名称",
    "announcement_desc":"公告说明",
    "announcement_same_date":"公告日期不能在同一日期",
    "app_announcement":"应用公告",
    "announcement_image":"图片",
    "announcement_current_name":"当前的标题",
    "announcement_new_name":"新标题",
    "announcement_current_desc":"当前说明",
    "announcement_new_desc":"新说明",
    "announcement_current_datefrom":"当前日期从",
    "announcement_new_datefrom":"新日期从",
    "announcement_current_dateto":"当前日期至",
    "announcement_new_dateto":"新日期到",
    "announcement_update_dtl":"更新公告详细信息",
    "announcement_info_updated":"公告详细信息已更新",
    "announcement_info_not_updated":"没有公告更新",
    "announcement_success_deactivated":"公告已成功停用",
    "announcement_failed_deactivated":"无法停用公告",
    "show_active_announcements":"显示活动公告",
    "show_inactive_announcements":"显示无效的公告",
    "failed_retrieve_announcements":"检索公告失败",
    "item_qty":"项目数量",
    "min_purchase":"最低购买量",
    "max_get":"最大物品获得",
    "min_price":"最低价格",
    "max_price":"最高价格",
    "search_item":"搜索产品",
    "custom_price":"定制价格",
    "choose_price":"选择价格",
    "foc":"附送",
    "item_price":"价格",
    "sameitem_foc":"相同产品免费",
    "lowest_foc":"最低价格免费",
    "choose_states":"选择州",
    "postage_fee":"邮费",
    "payment":"付款",
    "upload":"上载",
    "category_img":"上传类别图片",
    "remove_cat_image":"删除类别图片",
    "upload_success":"上传成功",
    "upload_fail":"上传失败",
    "upload_photo":"上传照片",
    "select_photo_category":"选择照片分类",
    "no_category_selected":"请至少选择一个分类",
    "no_image_selected":"请至少选择一张图片",
    "uploading":"上传中...",
    "deleted":"已删除！！！",
    "delete_fail":"删除失败",
    "available_qty":"可用数量",
    "price":"价钱",
    "qty":"数量",
    "edit_rec":"更改记录",
    "agent_list":"销售员列表",
    "checkin":"登记",
    "merchandising_checkin":"登记 (商品销售)",
    "promoter_checkin":"登记 (促销员)",
    "checkin_dtl":"登记详情",
    "checkout_dtl":"登出详情",
    "checkin_loaded":"登记数据已找到",
    "adver_status":"广告状态已更改",
    "show_all":"显示全部",
    "enter_item_name":"输入物品名称",
    "create_newsubcat":"创建新的细节分类",
    "subcat_list":"细节分类列表",
    "new_subcat":"新细节分类",
    "checkin_sched":"登记时间表",
    "search_agent":"搜寻销售员",
    "appointment_time":"预约在",
    "note_agent":"销售员须知",
    "sel_agent":"请选择销售员",
    "schedules":"时间表",
    "generate":"生成",
    "picking_list":"拾货列表",
    "delivery_info":"交货信息",
    "expected_del_date":"预计交货日期",
    "stock_transfer":"库存转移",
    "stock_take":"库存盘点",
    "stock_take_list":"库存盘点列表",
    "stock_take_details":"库存盘点物品",
    "backend_sync":"后端同步",
    "chg_new_cust":"更改新密码",
    "update_doc_dtl":"更新文件详细资料",
    "doc_info":"文件资讯",
    "cust_tel":"顾客电话号码",
    "deli_add_":"邮寄地址",
    "deli_add_1":"邮寄地址 1",
    "deli_add_2":"邮寄地址 2",
    "deli_add_3":"邮寄地址 3",
    "deli_add_4":"邮寄地址 4",
    "city":"城市",
    "state":"州区",
    "zipcode":"邮政编码",
    "country":"国家",
    "view":"观望",
    "search_item_type":"搜索项目类型",
    "item_not_exist":"记录中不存在该项目",
    "create_type":"创建项目类型",
    "add_item":"添加新项目",
    "knockoff_doc":"已付款文件",
    "no_knockoff_doc":"没有已付款的文件",
    "active_doc_loaded":"有效文件已加载",
    "inactive_doc_loaded":"无效文件已加载",
    "module_linkage":"连锁模块",
    "search_sku_item":"搜索SKU项目",
    "b2b_client":"B2B 客户",
    "b2b_client_list":"B2B客户名单",
    "b2b_client_capital":"B2B客户",
    "unlink_client":"取消链接",
    "link_client":"链接",
    "swap":"交换",
    "b2b_item_list":"B2B项目清单",
    "search_b2b_item":"搜索B2B项目",
    "unlink_item":"未链接产品",
    "search_customer":"搜索客户",
    "open_item":"链接一个产品",
    "room_name":"房间名称",
    "room_desc":"房间描述",
    "room_caseid":"案件编号",
    "open_room":"开启房间",
    "sku_item_list":"SKU项目清单",
    "date_range":"选择日期",
    "active_date_range":"生效日期范围",
    "outlet_visibility":"门店可见范围",
    "select_outlets":"选择门店...",
    "all_outlets":"全部门店",
    "visit_status":"拜访状态",
    "visited":"已拜访",
    "not_visited":"未拜访",
    "showing_all_outlets":"共显示 {count} 个门店",
    "select_all_outlets":"选择全部门店",
    "outlets_selected":"个门店已选",
    "search_outlets":"搜索连锁 / 门店...",
    "unit_chains":"连锁",
    "unit_outlets":"门店",
    "no_date_limit":"不限日期(永久生效)",
    "change_status":"切换状态",
    "in_range":"In Range",
    "stock_template_items":"Stock Template Items",
    "create_new":"Create New",
    "search_stock_template":"Search stock template",
    "stock_template_name":"Stock template name",
    "newstock_template_created":"New stock template is created",
    "stock_template_updated":"Stock template details is updated",
    "stock_template_deleted":"Stock template deleted",
    "no_stock_template":"No stock template found",
    "add_stock_template_item":"Add Stock Template Items",
    "stock_template_item":"Stock Template Items",
    "individual_item":"Individual Items",
    "item_template_pkg":"Item Template/Package",
    "last_5_inv":"Last 5 Invoices",
    "item_selection":"Item Selection",
    "select_cat_here":"Select category here..",
    "select_item_here":"Select item(s) here..",
    "select_package_here":"Select package here..",
    "select_inv_item_here":"Select invoices item(s) here..",
    "remove":"REMOVE",
    "stock_template_items_added":"Stock template item(s) added",
    "inv_items":"Invoice Items",
    "package":"Package",
    "current_items":"CURRENT ITEM(S)",
    "preview_video":"观看视频",
    "video":"视频",
    "paste_link_here":"在此处粘贴 YouTube 链接...",
    "pdf":"PDF",
    "pdf_list":"PDF列表",
    "preview":"预览",
    "image":"图片",
    "pdf_uploaded":"PDF文件上传成功！",
    "pdf_failed":"PDF文件上传失败",
    "video_uploaded":"视频上传成功！",
    "video_failed":"视频上传失败",
    "not_youtube_link":"这不是 YouTube 链接，请输入/粘贴正确的链接",
    "atch_delete":"您将要删除此附件。确定要继续吗？",
    "no_active_document":"没找到有效文件",
    "person_in_charge":"负责人",
    "set_due_date":"设置截止日期",
    "manage_sched":"管理时间表",
    "pending_sched":"等待中时间表",
    "time":"时间",
    "duration":"持续时间",
    "set_time":"具体时间",
    "set_duration":"具体持续时间",
    "instructions":"任何说明/注意事项?",
    "repeat_sched":"时间表重复",
    "single_customer":"单个客户",
    "multiple_customer":"多个客户",
    "customer_by_filter":"筛选出的顾客",
    "customer_by_area":"以地区找顾客",
    "fulltext_cust":"按地址/地区/州/国家/地区搜索",
    "pic_list":"负责人名单",
    "delete_recur":"删除重复事件",
    "delete_current":"删除当前事件",
    "edit_recur":"编辑重复事件",
    "edit_current":"编辑当前事件",
    "recur_msg":"时间表出现在重复事件。您可以选择对当前事件更改或所有相同事件同时进行更改",
    "target":"目标",
    "insert_success":"添加成功",
    "insert_fail":"添加失败",
    "not_found_target":"没找到目标",
    "not_found_Category":"没找到类别列表",
    "not_found_item":"没找到物品列表",
    "not_found_salesperson":"没找到销售员名单",
    "not_found_item_target":"没找到目标物品",
    "amount_empty":"请输入金额",
    "salesperson":"销售员",
    "edit_amount":"修改金额",
    "date_range_check":"请选择正确的日期，最少一个月",
    "target_empty":"请选择目标",
    "insert_item":"请选择物品",
    "insert_tag":"请选择标签",
    "confirm_update_request":"您要更新该目标信息还是创建新的目标？(新目标回保留该目标所有资料)",
    "submit":"提交",
    "add_new_tg_item":"添加新的物品在这个目标",
    "add_new_tg_tag":"添加新的标签在这个目标",
    "add_new_tag":"添加新的标签:",
    "confirm_update_tg":"确认跟新目标",
    "target_list":"目标",
    "nothing_save":"Nothing to save",
    "template_list":"Template List",
    "new_tmplt":"Create New Template",
    "delete_tmplt":"You are about to delete a template",
    "done":"DONE",
    "edit_tag":"修改标签",
    "yes":"是",
    "no":"不是",
    "category_empty":"请选着类别",
    "confirm_insert_details":"确认添加这个标签",
    "confirm_insert_all_details":"你要复制这标签的所有目标吗吗?",
    "no_attr_selected":"没选取任何属性",
    "empty_tag":"标签为空",
    "edit":"修改",
    "edit_quantity":"编辑数量",
    "edit_qty_failed":"更新数量失败",
    "duplicate":"复制",
    "edit_target":"Edit Target",
    "new_target":"Add New Target",
    "tag":"标签",
    "attribute":"属性",
    "generate_commission_report":"生成抽成报告",
    "report":"报告",
    "site_loc":"Site Location",
    "last_visit":"Last Visit",
    "branch":"Branch",
    "note":"Note",
    "phone_number":"Phone Number",
    "search_location":"Search Location",
    "contact_person":"Contact Person",
    "choose_project":"Projects",
    "avg_price_report":"Generate Average Price Report",
    "create_cust_grp":"Create customer group",
    "grp_of":"Group Of",
    "grp_members":"Group Members",
    "cash_rolling":"Cash Rolling",
    "cash_rolling_list":"Cash Rolling List",
    "amount":"金额",
    "new_cash_rolling":"New Cash Rolling",
    "remark":"标注",
    "cash_rolling_report":"Generate Cash Rolling Report",
    "b2border":"B2B Order",
    "item_link_success":"B2B item successfully linked!",
    "item_link_failed":"Failed to link B2B item!",
    "remove_customer_success":"B2B client successfully removed from the customer",
    "assign_customer_success":"B2B client successfully assigned to the customer",
    "assign_customer_failed":"Failed to assign B2B client to the customer",
    "sequence_update_success":"Sequence No. update success",
    "sequence_update_failed":"Sequence No. update failed",
    "driver_routing_report":"Generate Driver Routing Report",
    "must_push_noti":"You must enable push notification first",
    "no_modulename_found":"No module name found",
    "salesperson_list":"Agents",
    "bundle":"Bundle",
    "pwp":"PWP",
    "product":"产品",
    "new_bundle":"Add New Bundle",
    "foc_item":"附送物品",
    "cheaper_item":"折扣产品",
    "out_of":"Out Of",
    "cheaper_price":"折扣后价钱",
    "reportgenerator":"Report Generator",
    "transfer_doc_type_title":"Document Type when Transfer to Acc. System",
    "uom_price":"UOM Price",
    "special_price":"Special Price",
    "delivery_report":"Generate Delivery Report",
    "stock_adjustment":"Stock Adjustment",
    "dob":"Delivery On Behalf",
    "stock_transaction":"Stock Transactions",
    "voucher_report":"Voucher Redeemed Report",
    "order_report":"Order Report",
    "region":"地区",
    "stock_clearance":"Stock Clearance",
    "stock_clearance_list":"Stock Clearance List",
    "summary_report":"Summary Report",
    "doc_type":"Doc Type",
    "type":"Type",
    "teras_dashboard":"Teras Dashboard",
    "outlet_visit":"代理考勤",
    "outlet_visit_merchandising":"门店拜访 (商品销售)",
    "outlet_visit_promoter":"门店拜访 (促销员)",
    "agent_attend":"代理考勤",
    "promoter_attend":"促销员考勤",
    "outlet_code":"门店代号",
    "stock_count":"库存盘点",
    "generate_stock_count_report":"生成库存盘点报告",
    "outlet_category":"门店类别",
    "outlet_chain":"门店连锁",
    "outlet_area":"门店区域",
    "promoter_code":"促销员代号",
    "item_code":"商品代号",
    "item_name":"商品名称",
    "product_barcode":"商品条码",
    "product_category":"商品类别",
    "product_brand":"商品品牌",
    "opening_stock":"期初库存",
    "closing_stock":"期末库存",
    "sell_out":"售出",
    "sell_out_percentage":"售出百分比",
    "agent_name":"业务员姓名",
    "promoter_name":"促销员姓名",
    "ic_number":"身份证号码",
    "ic_image":"身份证图片",
    "check_in_time":"签到时间",
    "check_out_date":"签退日期",
    "check_out_time":"签退时间",
    "time_spent_hour":"用时 (小时)",
    "time_spent_minute":"用时 (分钟)",
    "checkin_coordinates":"签到坐标",
    "checkout_coordinates":"签退坐标",
    "sync_date":"同步日期",
    "sync_time":"同步时间",
    "out_of_stock":"缺货",
    "total_commission":"总佣金",
    "total_commission_cat":"类别总佣金",
    "total_commission_merchand":"推销总佣金",
    "total_st":"总库存",
    "total_photo":"总照片",
    "total_time_spent":"总花费时间",
    "total_break_time":"总休息时间",
    "stock_promotion_list":"Stock Promotion List",
    "add_stock_promotion":"Add Stock Promotion",
    "expiry_date":"过期日期",
    "promotion_content":"Promotion Content",
    "extend_date":"date is already expired, please change to extend",
    "current_img":"现在的图片",
    "product_name":"产品名称",
    "controller":"控制器",
    "operation":"操作",
    "insight":"洞察",
    "merchandising":"商品销售",
    "promoter":"促销员",
    "promoter_photo_categories":"促销员照片类别",
    "new_photo_category":"新建照片类别",
    "edit_photo_category":"编辑照片类别",
    "category_name":"类别名称",
    "this_month":"这个月",
    "stock_template":"库存模板",
    "location":"地方",
    "st_report":"Stock Take Report",
    "clear_all_data":"Clear All Data",
    "confirm_clear":"Are you sure you want to delete all the records for the selected location ?",
    "confirm":"Confirm",
    "route_id":"Route ID",
    "drivers":"司机",
    "assistant":"助理",
    "generate_type":"创建如一下选择",
    "product_uom":"产品单位",
    "product_desc":"产品描述",
    "barcode":"条码",
    "update_success":"更新成功",
    "update_fail":"更新失败",
    "new_uom":"添加新产品单位",
    "edit_uom":"更新产品单位",
    "product_code":"产品码",
    "edit_product_name":"修改产品名字",
    "outlet_name":"客户名字",
    "address1":"客户地址 1",
    "address2":"客户地址 2",
    "cust_code":"客户编号",
    "add_customer":"新客户",
    "edit_customer":"修改客户",
    "uom":"产品单位",
    "new_product":"新产品",
    "active_product":"有效产品",
    "inactive_product":"无效产品",
    "add_uom":"新产品单位",
    "delete_uom":"删除产品单位",
    "uomrate":"Rate",
    "schedule_status":"预定状态",
    "generate_agent_attend_report":"创建代理考勤报告",
    "generate_stock_take_report":"创建库存盘点报告",
    "generate_oos_report":"创建缺货报告",
    "generate_outlet_visit_report":"创建代理考勤报告",
    "generate_schedule_visit_report":"预定访问报告",
    "generate_stock_near_expiry_date_report":"创建库存过期报告",
    "generate_outlet_visit_frequency_report":"创建客户访问频率报告",
    "all":"全部",
    "oos":"缺货",
    "schedule_visit":"预定访问",
    "stock_near_expiry":"库存过期",
    "stock_near_expiry_analysis_by_item":"库存过期按物品",
    "outlet_visit_frequency":"客户访问频率",
    "brand":"品牌",
    "add_brand":"添加新品牌",
    "edit_brand":"编辑品牌",
    "category_list":"类别目录",
    "brand_list":"品牌目录",
    "category_code":"类别码",
    "category_name":"类别名称",
    "new_category":"新类别",
    "category_details":"类别明细",
    "brand_details":"品牌明细",
    "category_info":"类别信息",
    "brand_info":"品牌信息",
    "new_category_item":"添加新的类别商品",
    "new_brand_item":"添加新的品牌商品",
    "update_fail_brand":"Update Failed. Brand Code is Existed",
    "update_fail_category":"Update Failed. Category Code is Existed",
    "brand_img":"上传品牌照片",
    "remove_brand_image":"移除品牌照片",
    "cust_category_code":"客户类别码",
    "cust_category_name":"客户类别名称",
    "cust_chain_code":"客户链码",
    "cust_chain_name":"客户链名称",
    "new_cust_chain":"新客户链",
    "new_cust_category":"新客户类别",
    "cust_category_list":"客户类别列表",
    "cust_chain_list":"客户链列表",
    "cust_chain":"客户链",
    "cust_category":"客户类别",
    "cust_category_details":"客户类别信息",
    "cust_chain_details":"客户链信息",
    "update_fail_cust_category":"Update Failed. Customer Category Code is Existed",
    "update_fail_cust_chain":"Update Failed. Customer Chain Code is Existed",
    "template_item_list":"Template Item List",
    "compulsory":"必填",
    "compulsory_survey_hint":"业务员需先完成此问卷才能继续",
    "partially":"部分",
    "brand_code":"Brand Code",
    "brand_name":"Brand Name",
    "new_brand":"New Brand",
    "mileage": "Mileage",
    "user_settings": "User Settings",
    "user_details": "User Details",
    "email": "电子邮件",
    "contact_no": "联系电话",
    "name": "姓名",
    "login": "Login",
    "login_tagline": "Empower Your Field Team With Real-Time Insights",
    "login_subtitle": "Monitor outlet visits, track KPI performance, and optimize your merchandising and sales execution.",
    "login_feature_1": "Live GPS check-in & route tracking",
    "login_feature_2": "Real-time KPI & call rate dashboard",
    "login_feature_3": "Photo reporting with timestamp",
    "login_feature_4": "Promotion & stock visibility",
    "login_trusted_by": "Trusted by 50+ B2B Brands & Distributors",
    "login_portal_title": "Back Office Portal",
    "login_portal_subtitle": "Field Force Automation Platform",
    "login_access_dashboard": "Access Dashboard",
    "login_remember_me": "Remember me",
    "login_check_username": "Check your username",
    "login_check_password": "Check your password",
    "login_network_error": "网络错误，请重试",
    "network_error": "网络错误，请重试",
    "resigning": "Resigning User",
    "resign_user": "Resign User",
    "resign_user_confirm1": "Are you sure to resign this user?",
    "resign_user_confirm2": "如果是，请选择其他客户进行替换。",
    "user_access_regions": "客户访问区域",
    "regions_no_data": "该客户没有区域访问权限。",
    "position": "职位",
    "staff_code": "工号",
    "user_role": "用户角色",
    "manager": "经理",
    "refresh": "刷新",
    "view_columns": "显示列",
    "users_shown": "共 @total 位用户，显示 @shown 位",
    "no_role_assigned": "该用户未分配角色。",
    "user_group": "用户组",
    "no_group_found": "该用户暂无所属用户组。",
    "user_outlet_details": "客户插座详细信息",
    "user_outlet_list": "客户插座列表",
    "photo_gallery": "照片库",
    "promoter_photo_category": "照片库",
    "promotion": "促销",
    "promotion_types": "促销类型",
    "promotion_type_name": "类型名称",
    "active_promo": "生效促销",
    "new_promotion_type": "新增促销类型",
    "edit_promotion_type": "编辑促销类型",
    "promotion_type_delete": "您将要删除此促销类型。确定要继续吗？",
    "enter_promotion_type_name": "请输入类型名称",
    "no_promotion_types": "还没有促销类型",
    "promotion_types_empty_hint": "创建第一个类型来归类促销活动。",
    "promo_list":"促销列表",
    "new_promotion":"新增促销",
    "edit_promotion":"编辑促销",
    "promotion_details":"促销详情",
    "skus_in_promotion":"促销产品",
    "applicable_outlets":"适用门店",
    "compliance_tasks":"合规任务",
    "normal_price":"原价",
    "promo_price":"促销价",
    "start_date":"开始日期",
    "end_date":"结束日期",
    "task_start_date":"任务开始日期",
    "task_due_date":"任务截止日期",
    "task_description":"任务描述",
    "input_type":"输入类型",
    "applies_to":"适用范围",
    "all_skus":"全部产品",
    "specific_skus":"指定产品",
    "reference_photo":"参考图片",
    "required":"必填",
    "save_draft":"保存草稿",
    "publish":"发布",
    "published":"已发布",
    "upcoming":"即将开始",
    "draft":"草稿",
    "discard":"放弃",
    "view_report":"查看报告",
    "coming_soon":"下期开放",
    "notify":"通知",
    "tasks_unit":"个任务",
    "outlets_unit":"家门店",
    "all_brands":"全部品牌",
    "all_months":"全部月份",
    "select_chains":"步骤 1 — 选择连锁",
    "pick_outlets":"步骤 2 — 选择门店",
    "selected_outlets":"已选门店",
    "no_outlets_selected":"尚未选择门店",
    "outlets_selected_count":"家门店已选",
    "add_sku":"添加产品",
    "add_task":"添加任务",
    "select_brand_first":"请先选择品牌",
    "sku_already_added":"该产品已在清单中",
    "change_brand_confirm":"更换品牌将清空已选产品清单,是否继续?",
    "unsaved_changes_confirm":"有未保存的修改,确定放弃?",
    "delete_promotion_confirm":"确定删除此促销?",
    "promo_price_warning":"促销价不低于原价",
    "task_notify_hint":"任务开始日期为通知日,推送功能下期开放。",
    "task_due_hint":"任务截止日期必须早于促销开始日期。",
    "publish_success":"促销已发布",
    "draft_saved":"草稿已保存",
    "no_promotions":"暂无促销",
    "promotions_empty_hint":"创建第一个促销,指定产品、门店与合规任务。",
    "err_name_required":"促销名称必填",
    "err_brand_required":"品牌必填",
    "err_dates_required":"起止日期必填",
    "err_date_order":"开始日期必须早于结束日期",
    "err_min_one_sku":"至少添加一个产品",
    "err_promo_price_required":"每个产品都需要促销价",
    "err_min_one_outlet":"至少选择一家门店",
    "err_min_one_task":"至少添加一个任务",
    "err_task_desc_required":"每个任务都需要描述",
    "err_task_skus_required":"指定产品任务至少选择一个产品",
    "err_task_dates_required":"任务起止日期必填",
    "err_task_date_order":"任务开始日期必须早于截止日期",
    "err_task_due_before_start":"任务截止日期必须早于促销开始日期",
    "promotion_name":"促销名称",
    "select_all":"全选",
    "text":"文字",
    "number":"数字",
    "checkbox":"勾选框",
    "photo":"图片",
    "expired":"已过期",
    "month":"月份",
    "action": "操作",
    "confirmation": "确认",
    "check_all":"选择所有",
    "all_day": "一整天",
    "due_date":"截止日期",
    "incentive": "促销员激励",
    "stock_level_tooltip": "启用/禁用库存水平",
    "stock_level_settings": "设置库存水平数量",
    "stock_level_set_title": "设置库存水平数量",
    "stock_level_set_desc": "输入该产品每个水平代表多少单位。",
    "stock_level_low": "低",
    "stock_level_medium": "中",
    "stock_level_high": "高",
    "stock_level_units": "单位",
    "stock_level_eg": "例如",
    "stock_level_qty_updated": "库存水平数量已更新",
    "stock_level_qty_failed": "更新库存水平数量失败",
    "unsched_outlet_visit": "计划外的客户店参观",
    "uncheduled": "计划外",
    "copy_user": "复制用户",
    "cancelled": "取消",
    "copy_user_confirm1": "复制将替换对方现有数据，请谨慎选择。",
    "copy_user_confirm2": "如果您已决定，请选择要更换的用户。",
    "competitor_price_checking": "竞争对手价格查询",
    "competitor": "竞争者",
    "edit_competitor": "编辑竞争对手",
    "add_competitor": "添加竞争对手",
    "competitor_code": "竞争对手代码",
    "competitor_name": "竞争对手名称",
    "description": "描述",
    "competitor_details": "竞争对手详情",
    "competitor_products": "竞争对手产品",
    "competitor_product_category": "竞争对手产品类别",
    "add_product": "添加产品",
    "add_category": "添加类别",
    "competitor_product_details": "竞争对手产品详情",
    "edit_product": "编辑产品",
    "competitor_category_details": "竞争对手类别详细信息",
    "category_products": "类别产品",
    "assign_product": "分配产品",
    "edit_category": "编辑类别",
    "missedwreason": "有理由错过",
    "frequency_list": "频率列表",
    "posm": "POSM",
    "checklist": "CHECKLIST",
    "area": "地区",
    "agent_attend_insight": "Agent Attendance Insight",
    "outlet_visit_insight": "Outlet Visited Insight",
    "rdisplay": "Display %",
    "rsku": "SKU %",
    "new_batch_no": "New Batch No",
    "batch_no": "Batch No",
    "show_inactive_batch": "显示无效批号",
    "show_active_batch": "仅显示有效批号",
    "show_inactive_barcode": "显示无效条码",
    "show_active_barcode": "仅显示有效条码",
    "outlet_visit_analysis": "Outlet Visit Analysis",
    "chain": "Chain",
    "item_chain_code": "商品连锁编码",
    "item_chain_code_list": "商品连锁编码列表",
    "new_item_chain_code": "新增商品连锁编码",
    "edit_item_chain_code": "编辑商品连锁编码",
    "select_chain": "选择连锁",
    "select_uom": "选择单位",
    "field_required": "为必填项",
    "barcode_list": "条码列表",
    "new_barcode": "新增条码",
    "edit_barcode": "编辑条码",
    "table_analysis_report": "Table Analysis Report",
    "rCompetitorPriceCheck": "Competitor Price Check",
    "rCompetitorPriceCheckAnalysis": "Competitor Price Check Analysis",
    "cust_type": "客户类型",
    "cust_type_list": "客户类型列表",
    "cust_type_code": "客户类型链码",
    "cust_type_name": "客户类型名称",
    "cust_type_details": "客户类型信息",
    "update_fail_cust_type":"Update Failed. Customer Type Code is Existed",
    "new_cust_type":"新客户类型",
	  "cust_area": "Outlet Area",
	  "new_cust_area":"New Outlet Area",
	  "cust_area_code": "Outlet Area Code",
    "cust_area_name": "Outlet Area Name",
    "cust_area_details": "Outlet Area Info",
    "tutorials": "教程",
    "tutorial_library_subtitle": "查找所需教程，按自己的节奏学习。",
    "tutorial_search_placeholder": "搜索教程",
    "tutorial_video_count": "个视频",
    "tutorial_watch": "观看教程",
    "tutorial_load_failed": "教程加载失败",
    "tutorial_retry": "重试",
    "system_settings":"System Settings",
    "photo_type": "Photo Type",
    "photo_taken_analysis": "Photo Taken Analysis",
    "photo_taken": "Photo Taken",
    "google_location_tracking": "Google位置追踪",
    "download": "Download",
    "downloading": "下载中...",
    "download_success": "下载成功",
    "download_failed": "下载失败",
    "item_distribution_analysis": "Item Distribution By Item",
    "item_distribution_analysis_by_agent": "Item Distribution By Agent",
    "stock_near_expiry_analysis" : "Stock Near Expiry Analysis",
    "export_template":"导出模板",
    "export":"导出",
    "import_csv":"导入 .CSV",
    "bulk_import_new": "新增",
    "bulk_import_update": "更新",
    "bulk_import_status": "状态",
    "bulk_import_inserted": "新增",
    "bulk_import_updated": "更新",
    "bulk_import_check_error": "检查门店时出错",
    "bulk_import_network_error": "网络错误",
    "stock_near_expiry_analysis_by_day": "Stock Near Expiry Analysis (By Day)",
    "survey_form": "表单",
    "csr_activity": "CSR Activity",
    "survey_response": "表单回应",
    "survey_title": "问卷标题",
    "submission_date": "提交日期",
    "check_in": "签到",
    "check_out": "签退",
    "photo_viewer_drag_hint": "拖动图片或使用方向键移动",
    "survey_response_details": "表单回应详情",
    "download_pdf": "下载 PDF",
    "no_answer": "暂无回答",
    "no_image_available": "暂无图片",
    "question_abbr": "Q",
    "qtype_text": "文本",
    "qtype_rating": "评分",
    "qtype_choice": "多选",
    "qtype_photos": "照片",
    "column_layout_saved": "列布局已保存",
    "column_layout_save_failed": "保存列布局失败",
    "manage_users": "管理用户",
    "user_management": "用户管理",
    "user_account": "用户账号",
    "active_user_quota": "活跃用户配额",
    "quota_exceeded": "活跃用户配额已达上限",
    "user_exists_active": "此用户名正在使用中",
    "name_label": "名称",
    "is_required": "为必填",
    "personal": "个人资料",
    "working_time": "工作时间",
    "bank_details": "银行资料",
    "ic_no": "身份证号",
    "address": "地址",
    "start_time": "开始时间",
    "end_time": "结束时间",
    "rest_day": "休息日",
    "select_rest_day": "选择休息日",
    "repeats_every": "每隔",
    "rest_start_date": "起始日期",
    "rest_start_date_required": "请选择起始日期",
    "branch_required": "请选择分行",
    "week": "周",
    "bank_name": "银行",
    "bank_account_number": "银行账号",
    "bank_account_name": "户名",
    "edit_user": "编辑用户",
    "select_role": "选择角色",
    "sun": "日",
    "mon": "一",
    "tue": "二",
    "wed": "三",
    "thu": "四",
    "fri": "五",
    "sat": "六",
    "password_changed": "密码已更改",
    "user_activated": "用户已启用",
    "user_deactivated": "用户已停用",
    "created_date": "创建时间",
    "inactive_date": "停用时间",
    "last_updated_date": "最近更新",
    "by": "由",
    "activate": "启用",
    "deactivate": "停用",
    "account_info": "账号资料",
    "optional": "选填",
    "no_limit": "无上限",
    "check_in_date": "打卡日期",
    "places": "地点",
    "agent_code": "销售员代码",
    "checkin_settings": "打卡",
    "checkin_settings_subtitle": "设置代表的打卡要求。",
    "checkin_selfie_mandatory": "打卡、退卡拍照强制",
    "checkin_selfie_desc": "开启后，代表在打卡和退卡前需要拍摄自拍照。",
    "limit_checkin_radius": "限制打卡半径",
    "limit_checkin_radius_desc": "开启后，代表只能在当前位置的指定半径范围内打卡。",
    "minimum_radius_note": "注意：最小半径应设置为300米。",
    "limit_checkout_radius": "限制退卡半径",
    "limit_checkout_radius_desc": "开启后，代表只能在当前位置的半径范围内退卡。",
    "radius_setting": "半径设置",
    "feedback": "反馈",
    "feedback_title": "反馈标题",
    "feedback_listing": "反馈列表",
    "announcement":"公告",
    "announcement_compose":"撰写",
    "announcement_manage":"管理",
    "announcement_inbox":"收件箱",
    "announcement_title":"标题",
    "announcement_content":"内容",
    "announcement_attachments":"附件",
    "announcement_youtube_url":"YouTube / 视频链接",
    "announcement_youtube_invalid":"无效的链接",
    "announcement_add":"添加",
    "announcement_audience":"接收客户",
    "announcement_all_clients":"全部客户",
    "announcement_recipients":"接收人数",
    "announcement_priority":"优先级",
    "announcement_priority_info":"一般",
    "announcement_priority_important":"重要",
    "announcement_publish_date":"发布日期",
    "announcement_publish_date_hint":"不选日期则立即发布",
    "announcement_save_draft":"保存草稿",
    "announcement_publish":"发布",
    "announcement_published":"已发布",
    "announcement_draft":"草稿",
    "announcement_drafts":"草稿",
    "announcement_all":"全部",
    "announcement_unread":"未读",
    "announcement_read_rate":"已读",
    "announcement_actions":"操作",
    "announcement_retract":"撤回",
    "announcement_retract_confirm":"确定撤回这条公告?它将从所有客户的收件箱消失,并变回草稿。",
    "announcement_delete_confirm":"确定删除这条草稿?删除后无法恢复。",
    "announcement_select_to_read":"选择一条公告查看",
    "announcement_no_data":"暂无公告",
    "announcement_notifications":"通知",
    "announcement_no_unread":"没有未读公告",
    "announcement_new_popup_title":"新公告",
    "announcement_new_popup_desc":"您有来自EasyM的未读公告:",
    "announcement_view":"查看",
    "announcement_add_image":"+ 图片",
    "announcement_add_video":"+ 视频",
    "announcement_add_pdf":"+ PDF",
    "announcement_add_youtube":"视频链接",
    "announcement_users":"个用户",
    "announcement_specific_users":"指定用户(可选)",
    "announcement_all_users_in_clients":"全部用户",
    "announcement_priority_critical":"紧急",
    "announcement_file_too_large":"文件超过 50MB",
    "announcement_too_many_files":"附件最多 10 个",
    "announcement_file_type_invalid":"文件类型不支持",
    "feedback_detail": "反馈详情",
    "feedback_status_pending_resolve": "待处理",
    "feedback_status_resolved": "已解决",
    "feedback_description": "描述",
    "feedback_images": "上传的图片",
    "feedback_update": "更新反馈",
    "feedback_add_title": "添加反馈标题",
    "feedback_active_filters": "筛选条件",
    "feedback_results": "条结果",
    "clear_all": "清除全部",
    "feedback_confirm_status": "确定更新状态为",
    "feedback_status_updated": "已更新状态为",
    "working_shift": "工作班次",
    "shift_name": "班次名称",
    "start_time": "开始时间",
    "end_time": "结束时间",
    "payout": "薪资",
    "total_hours": "总时数",
    "add_working_shift": "添加工作班次",
    "edit_working_shift": "编辑工作班次",
    "action": "操作",
    "undo": "撤回",
    "leaves": "请假",
    "leaves_listing": "请假列表",
    "leave_type": "请假类型",
    "leave_type_desc": "管理员工可用的请假类型。",
    "leave_types": "请假类型",
    "leave_type_code": "类型代号",
    "leave_type_name": "类型名称",
    "add_leave_type": "添加请假类型",
    "edit_leave_type": "编辑请假类型",
    "reason_required": "需要原因",
    "attachment_required": "需要附件",
    "apply_date": "申请日期",
    "leave_days": "天数",
    "leave_from": "起始日期",
    "leave_to": "结束日期",
    "session_am": "早上",
    "session_pm": "下午",
    "leave_reason": "请假原因",
    "agent": "代理",
    "approved": "已批准",
    "rejected": "已拒绝",
    "approved_by": "批准人",
    "approved_date": "批准日期",
    "rejected_by": "拒绝人",
    "rejected_date": "拒绝日期",
    "reject_reason": "拒绝原因",
    "reject_reason_required": "请输入拒绝原因",
    "leave_name_required": "请输入姓名",
    "generate_report": "生成报表",
    "generating_report_loading": "正在生成报表...",
    "leave_confirm_status": "确定更新假期状态为",
    "leave_status_updated": "假期状态已更新为",
    "outlet_code_desc": "门店编号自动生成规则（只读）。",
    "next_running_no": "下一个流水号",
    "reference_no": "参照号",
    "code_format": "编号格式",
    "photo_type_desc": "管理照片类别，拖拽排序后发布。",
    "photo_type_v2_desc": "管理照片分组与类型，并发布显示顺序。",
    "feedback_title_desc": "管理 App 反馈表单可使用的标题选项。",
    "promoter_photo_categories_desc": "管理促销员可使用的照片类别。",
    "working_shift_desc": "定义排班时可使用的工作班次。",
    "publish_sequence": "发布排序",
    "modified": "已修改",
    "reset": "重置",
    "filter_table": "表格筛选",
    "saved": "已保存",
    "commission": "佣金",
    "name_required": "名称不能为空。",
    "required_fields": "请填写所有必填字段。",
    "max_photo_error": "最多照片必须大于 0。",
    "min_photo_error": "最少照片不能大于最多照片。",
    "breadcrumb": "当前位置",
    "root": "根目录",
    "reorder": "重新排序",
    "gallery_group": "照片分组",
    "min_photo": "最少照片",
    "max_photo": "最多照片",
    "group_type": "分组 / 类型",
    "qty_needed": "需要数量",
    "code": "编号",
    "group": "分组",
    "inactivate_outlet":"停用 Outlet",
    "outlet_tied_to_schedule":"此 Outlet 已被排入拜访排程",
    "outlet_scheduled_visits":"目前有以下拜访排程：",
    "appointment":"拜访排程",
    "visit_schedule":"拜访计划",
    "visits":"笔",
    "next":"最近",
    "inactivate_remove_schedule_warning":"停用后会自动从以上排程移除。此操作无法撤销，重新启用后需要重新安排。",
    "inactivate_outlet_confirm":"确定要停用此 Outlet？",
    "inactivate_and_remove":"停用并移除排程",
    "inactivate":"停用",
    "activate_outlet":"启用 Outlet",
    "activate_outlet_confirm":"确定要启用此 Outlet？",
    "activate":"启用",
    "audit_trail":"活动日志",
    "timestamp":"时间",
    "performed_by":"操作人",
    "role_admin":"管理员",
    "ip_address":"IP 地址",
    "record_id":"记录 ID",
    "all_actions":"全部操作",
    "all_users":"全部用户",
    "action_create":"新增 Outlet",
    "action_update":"编辑 Outlet",
    "action_active":"设为启用",
    "action_inactive":"设为停用",
    "field_changes":"栏位变更",
    "value_before":"变更前",
    "value_after":"变更后",
    "reason_note":"原因 / 备注",
    "reason_required":"请填写原因",
    "no_matching_events":"没有符合的记录",
    "no_matching_events_hint":"请调整上方的筛选条件或日期范围。",
    "audit_legacy_record":"此记录早于活动日志功能上线，未记录操作人与 IP。",
    "audit_system_user":"系统",
    "audit_no_field_changes":"此类操作没有栏位层级的变更记录",
    "longitude":"经度",
    "latitude":"纬度",
    "address_2":"地址 2",
    "updated_by":"更新者",
    "created_by":"创建者",
    "created_date":"创建日期",
    "company":"公司",
    "action_assign":"分配员工",
    "action_unassign":"取消分配员工",
    "assigned_user":"负责员工",
    "audit_source":"来源",
    "audit_src_outlet_detail":"Outlet 详情 - 员工",
    "audit_src_outlet_create":"新增 Outlet",
    "audit_src_outlet_edit":"编辑 Outlet",
    "audit_src_user_outlet":"用户设置 - Outlet",
    "audit_src_resign":"用户设置 - 离职转移",
    "audit_src_copy":"用户设置 - 复制 Outlet",
    "audit_src_checkin_approve":"Check-in 审批",
    "attachment":"附件",
    "upload_attachment":"上传附件",
    "uploaded_by":"上传者",
    "uploaded_on":"上传日期",
    "file_size":"大小",
    "files":"个文件",
    "no_attachments_yet":"暂无附件",
    "no_attachments_hint":"上传此用户的合同、文件或任何档案。",
    "drag_drop_hint":"将文件拖放到此处，或",
    "browse":"浏览",
    "max_file_size_hint":"任何格式 · 最大 10 MB",
    "file_too_large":"文件超过 10 MB 限制",
    "attachment_uploaded":"附件已上传",
    "attachment_deleted":"附件已删除",
    "delete_attachment_title":"删除附件？",
    "delete_attachment_message":"将从此用户移除。此操作无法撤销。",
    "remark_optional":"备注（可选）",
    "zoom_in":"放大",
    "zoom_out":"缩小",
    "rotate_left":"向左旋转",
    "rotate_right":"向右旋转",
    "save_rotation":"保存",
    "rotation_saved":"图片已保存",
    "rotation_failed":"图片保存失败",
    "drag_to_move_hint":"拖动移动或使用方向键",
    "open_in_new_tab":"在新标签页打开",
    "previous_file":"上一个",
    "next_file":"下一个",
    "preview_failed":"预览加载失败",
    "showing_first_rows":"仅显示前几行：",
    "loading":"加载中...",
  }
}
export default translations;
